var groups = {
	blocto: {
		brand: {
			alt: "Blocto",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		key: "blocto",
		wallets: [
			{
				brand: {
					alt: "Blocto Wallet",
					primaryColor: "#5E678A",
					spriteId: "blocto"
				},
				group: "blocto",
				mobile: {
					androidId: "com.portto.blocto",
					iosId: "id1481181682"
				},
				name: "Blocto (Flow)"
			},
			{
				brand: {
					alt: "Blocto Wallet",
					primaryColor: "#5E678A",
					spriteId: "blocto"
				},
				group: "blocto",
				mobile: {
					androidId: "com.portto.blocto",
					iosId: "id1481181682"
				},
				name: "Blocto (EVM)"
			}
		]
	},
	brave: {
		brand: {
			alt: "Brave Browser",
			primaryColor: "#4B49C6",
			spriteId: "brave"
		},
		key: "brave",
		wallets: [
			{
				brand: {
					alt: "Brave Browser",
					primaryColor: "#F39020",
					spriteId: "brave"
				},
				group: "brave",
				mobile: {
					androidId: "com.brave.browser",
					iosId: "id1052879175"
				},
				name: "Brave Browser (EVM)"
			},
			{
				brand: {
					alt: "Brave Browser",
					primaryColor: "#4B49C6",
					spriteId: "brave"
				},
				group: "brave",
				mobile: {
					androidId: "com.brave.browser",
					iosId: "id1052879175"
				},
				name: "Brave Browser (Solana)"
			}
		]
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		key: "coinbase",
		wallets: [
			{
				brand: {
					alt: "Coinbase Wallet",
					primaryColor: "#1648F9",
					spriteId: "coinbase"
				},
				desktop: {
					chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
				},
				group: "coinbase",
				mobile: {
					androidId: "org.toshi",
					iosId: "id1278383455"
				},
				name: "Coinbase Wallet"
			},
			{
				brand: {
					alt: "Coinbase Wallet",
					primaryColor: "#1648F9",
					spriteId: "coinbase"
				},
				desktop: {
					chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
				},
				group: "coinbase",
				name: "Coinbase Wallet (Solana)"
			}
		]
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		key: "exodus",
		wallets: [
			{
				brand: {
					alt: "Exodus Wallet",
					spriteId: "exodus"
				},
				desktop: {
					chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
				},
				group: "exodus",
				mobile: {
					androidId: "exodusmovement.exodus",
					iosId: "id1414384820"
				},
				name: "Exodus Wallet (EVM)"
			},
			{
				brand: {
					alt: "Exodus Wallet",
					spriteId: "exodus"
				},
				desktop: {
					chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
				},
				group: "exodus",
				mobile: {
					androidId: "exodusmovement.exodus",
					iosId: "id1414384820"
				},
				name: "Exodus Wallet (Solana)"
			}
		]
	},
	phantom: {
		brand: {
			alt: "Phantom",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		key: "phantom",
		wallets: [
			{
				brand: {
					alt: "Phantom Wallet",
					primaryColor: "#4B49C6",
					spriteId: "phantom"
				},
				desktop: {
					chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
					firefoxId: "phantom-app"
				},
				group: "phantom",
				mobile: {
					androidId: "app.phantom",
					iosId: "id1598432977"
				},
				name: "Phantom"
			},
			{
				brand: {
					alt: "Phantom Wallet",
					primaryColor: "#4B49C6",
					spriteId: "phantom"
				},
				desktop: {
					chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
					firefoxId: "phantom-app"
				},
				group: "phantom",
				mobile: {
					androidId: "app.phantom",
					iosId: "id1598432977"
				},
				name: "Phantom (EVM)"
			}
		]
	}
};
var wallets = {
	metamask: {
		brand: {
			alt: "MetaMask Wallet",
			primaryColor: "#E8831D",
			spriteId: "metamask"
		},
		chains: [
			"eip155:1"
		],
		desktop: {
			chromeId: "nkbihfbeogaeaoehlefnkodbefgpgknn",
			edgeId: "ejbalbakoplchlghecdalmeeeajnimhm",
			firefoxId: "ether-metamask"
		},
		mobile: {
			androidId: "io.metamask",
			iosId: "id1438144202",
			native: "metamask://wc",
			universal: "https://metamask.app.link/wc"
		},
		name: "MetaMask",
		shortName: "MetaMask",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	trust: {
		brand: {
			alt: "Trust Wallet",
			imageId: "0528ee7e-16d1-4089-21e3-bbfb41933100",
			primaryColor: "#3375bb"
		},
		chains: [
			"eip155:1"
		],
		desktop: {
			chromeId: "egjidjbpglichdcondbcbdnbeeppgdph"
		},
		mobile: {
			androidId: "com.wallet.crypto.trustapp",
			iosId: "id1288339409",
			native: "trust://wc"
		},
		name: "Trust Wallet",
		shortName: "Trust",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	safe: {
		brand: {
			alt: "Safe Wallet",
			imageId: "3913df81-63c2-4413-d60b-8ff83cbed500",
			primaryColor: "#12FF80"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1313161554",
			"eip155:137",
			"eip155:246",
			"eip155:4",
			"eip155:42161",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:73799"
		],
		mobile: {
			androidId: "io.gnosis.safe",
			iosId: "id1515759131",
			native: "safe://wc",
			universal: "https://app.safe.global/wc"
		},
		name: "Safe",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	rainbow: {
		brand: {
			alt: "Rainbow Wallet",
			primaryColor: "#001e59",
			spriteId: "rainbow"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "me.rainbow",
			iosId: "id1457119021",
			native: "rainbow://wc",
			universal: "https://rnbwapp.com/wc"
		},
		name: "Rainbow",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	uniswap: {
		brand: {
			alt: "Uniswap Wallet",
			imageId: "bff9cf1f-df19-42ce-f62a-87f04df13c00",
			primaryColor: "#F42BD2"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161"
		],
		mobile: {
			iosId: "id6443944476",
			native: "uniswap://wc",
			universal: "https://uniswap.org/app/wc"
		},
		name: "Uniswap Wallet",
		shortName: "Uniswap",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	zerion: {
		brand: {
			alt: "Zerion Wallet",
			imageId: "f216b371-96cf-409a-9d88-296392b85800",
			primaryColor: "#2962ef"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1313161554",
			"eip155:137",
			"eip155:200",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			native: "zerion://wc",
			universal: "https://wallet.zerion.io"
		},
		mobile: {
			androidId: "io.zerion.android",
			iosId: "id1456732565",
			native: "zerion://wc",
			universal: "https://wallet.zerion.io/wc"
		},
		name: "Zerion",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	imtoken: {
		brand: {
			alt: "imToken Wallet",
			imageId: "99520548-525c-49d7-fb2f-5db65293b000",
			primaryColor: "#098DE6"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:1001",
			"eip155:128",
			"eip155:137",
			"eip155:1666600000",
			"eip155:1666700000",
			"eip155:25",
			"eip155:256",
			"eip155:338",
			"eip155:420",
			"eip155:42220",
			"eip155:43110",
			"eip155:43114",
			"eip155:44787",
			"eip155:5",
			"eip155:56",
			"eip155:65",
			"eip155:66",
			"eip155:80001",
			"eip155:8217",
			"eip155:97"
		],
		mobile: {
			androidId: "im.token.app",
			iosId: "id1384798940",
			native: "imtokenv2://wc"
		},
		name: "imToken",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	argent: {
		brand: {
			alt: "Argent Wallet",
			imageId: "215158d2-614b-49c9-410f-77aa661c3900"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "im.argent.contractwalletclient",
			iosId: "id1358741926",
			native: "argent://wc"
		},
		name: "Argent",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	spot: {
		brand: {
			alt: "Spot Wallet",
			imageId: "1bf33a89-b049-4a1c-d1f6-4dd7419ee400",
			primaryColor: "#29C0FF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "pfdaepphglddodhkmcfoefimbcnkipmn"
		},
		mobile: {
			androidId: "com.spot.spot",
			iosId: "id1390560448",
			native: "spot://wc",
			universal: "https://spot.so/wc"
		},
		name: "Spot",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	omni: {
		brand: {
			alt: "Omni Wallet",
			imageId: "2cd67b4c-282b-4809-e7c0-a88cd5116f00",
			primaryColor: "#FFFFFF"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"cosmos:kava-4",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:1666600000",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "fi.steakwallet.app",
			iosId: "id1569375204",
			native: "omni://wc",
			universal: "https://links.omni.app/wc"
		},
		name: "Omni",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cryptocom: {
		brand: {
			alt: "Crypto.com Wallet",
			imageId: "7c5ff577-a68d-49c5-02cd-3d83637b0b00",
			primaryColor: "#1199FA"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:108",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:42161",
			"eip155:42220",
			"eip155:56",
			"eip155:8217"
		],
		name: "Crypto.com | DeFi Wallet",
		shortName: "Crypto.com",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	tokenpocket: {
		brand: {
			alt: "TokenPocket Wallet",
			imageId: "f3119826-4ef5-4d31-4789-d4ae5c18e400",
			primaryColor: "#2982fe"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:10000",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:1666600000",
			"eip155:170",
			"eip155:250",
			"eip155:321",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:59",
			"eip155:61",
			"eip155:65",
			"eip155:66",
			"eip155:8217"
		],
		desktop: {
			chromeId: "mfgccjchihfkkindfppnaooecgfneiii"
		},
		mobile: {
			androidId: "vip.mytokenpocket",
			iosId: "id6444625622",
			native: "tpoutside://wc"
		},
		name: "TokenPocket",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	robinhoodwallet: {
		brand: {
			alt: "Robinhood Wallet Wallet",
			imageId: "dfe0e3e3-5746-4e2b-12ad-704608531500"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			ios: "https://robinhood.com/web3-wallet/",
			native: "robinhood-wallet://wc"
		},
		name: "Robinhood Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	frontier: {
		brand: {
			alt: "Frontier Wallet",
			imageId: "a78c4d48-32c1-4a9d-52f2-ec7ee08ce200",
			primaryColor: "#CC703C"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"cosmos:kava-4",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:122",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:1666600000",
			"eip155:25",
			"eip155:250",
			"eip155:288",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:4689",
			"eip155:56",
			"eip155:8217",
			"eip155:88",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "kppfdiipphfccemcignhifpjkapfbihd"
		},
		mobile: {
			androidId: "com.frontierwallet",
			iosId: "id1482380988",
			native: "frontier://wc"
		},
		name: "Frontier",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	blockchain: {
		brand: {
			alt: "Blockchain Wallet",
			imageId: "6f913b80-86c0-46f9-61ca-cc90a1805900",
			primaryColor: "#0C6CF2"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "piuk.blockchain.android",
			iosId: "id493253309",
			native: "blockchain-wallet://wc"
		},
		name: "Blockchain.com",
		shortName: "Blockchain",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	safepal: {
		brand: {
			alt: "SafePal Wallet",
			imageId: "252753e7-b783-4e03-7f77-d39864530900",
			primaryColor: "#4A21EF"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"cosmos:kava-4",
			"eip155:1",
			"eip155:10000",
			"eip155:122",
			"eip155:1313161554",
			"eip155:137",
			"eip155:14",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:19",
			"eip155:200",
			"eip155:25",
			"eip155:250",
			"eip155:288",
			"eip155:30",
			"eip155:361",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:56",
			"eip155:6",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"stellar:pubnet"
		],
		desktop: {
			chromeId: "lgmpcpglpngdoalbgeoldeajfclnhafa",
			edgeId: "apenkfbbpmhihehmihndmmcdanacolnh",
			firefoxId: "safepal-extension-wallet"
		},
		mobile: {
			androidId: "io.safepal.wallet",
			iosId: "id1548297139",
			native: "safepalwallet://wc",
			universal: "https://link.safepal.io/wc"
		},
		name: "SafePal",
		switchNetworkOnlyFromWallet: true,
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bitkeep: {
		brand: {
			alt: "BitKeep Wallet",
			imageId: "3f7075d0-4ab7-4db5-404d-3e4c05e6fe00"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:128",
			"eip155:137",
			"eip155:56",
			"eip155:66",
			"eip155:8217"
		],
		desktop: {
			chromeId: "jiidiaalihmmhddjgbnbgdfflelocpak"
		},
		mobile: {
			android: "https://bitkeep.com/download",
			ios: "https://bitkeep.com/download",
			native: "bitkeep://wc",
			universal: "https://bkapp.vip/wc"
		},
		name: "BitKeep",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	zengo: {
		brand: {
			alt: "Zengo Wallet",
			primaryColor: "#200C5B",
			spriteId: "zengo"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.zengo.wallet",
			iosId: "id1440147115",
			native: "zengo://wc",
			universal: "https://get.zengo.com/wc"
		},
		name: "Zengo Wallet",
		shortName: "Zengo",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	"1inch": {
		brand: {
			alt: "1inch Wallet",
			imageId: "52b1da3c-9e72-40ae-5dac-6142addd9c00",
			primaryColor: "#2F8AF5"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1313161554",
			"eip155:137",
			"eip155:250",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:8217"
		],
		mobile: {
			androidId: "io.oneinch.android",
			iosId: "id1546049391",
			native: "oneinch://wc"
		},
		name: "1inch Wallet",
		shortName: "1inch",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	binance: {
		brand: {
			alt: "Binance Wallet",
			imageId: "ebac7b39-688c-41e3-7912-a4fefba74600"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:324",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			android: "https://www.binance.com/en/download",
			ios: "https://www.binance.com/en/download",
			native: "bnc://wc",
			universal: "https://app.binance.com/cedefi/wc"
		},
		name: "Binance DeFi Wallet",
		shortName: "Binance",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			imageId: "4c16cad4-cac9-4643-6726-c696efaf5200"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820",
			native: "exodus://wc"
		},
		name: "Exodus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ledger: {
		brand: {
			alt: "Ledger Wallet",
			imageId: "a7f416de-aa03-4c5e-3280-ab49269aef00",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:4",
			"eip155:56"
		],
		desktop: {
			native: "ledgerlive://wc"
		},
		mobile: {
			androidId: "com.ledger.live",
			iosId: "id1361671700",
			native: "ledgerlive://wc"
		},
		name: "Ledger Live",
		shortName: "Ledger",
		switchNetworkOnlyFromWallet: true,
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mewwallet: {
		brand: {
			alt: "MEW wallet Wallet",
			imageId: "e2024511-2c9b-46d7-3111-52df3d241700",
			primaryColor: "#05C0A5"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.myetherwallet.mewwallet",
			iosId: "id1464614025",
			native: "mewwallet://wc"
		},
		name: "MEW wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	alphawallet: {
		brand: {
			alt: "AlphaWallet Wallet",
			imageId: "5b1cddfb-056e-4e78-029a-54de5d70c500",
			primaryColor: "#ffffff"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:11297108099",
			"eip155:11297108109",
			"eip155:137",
			"eip155:200",
			"eip155:256",
			"eip155:3",
			"eip155:338",
			"eip155:4",
			"eip155:4002",
			"eip155:42",
			"eip155:42161",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:61",
			"eip155:69",
			"eip155:77",
			"eip155:97",
			"eip155:99"
		],
		mobile: {
			androidId: "io.stormbird.wallet",
			iosId: "id1358230430",
			native: "awallet://wc",
			universal: "https://aw.app/wc"
		},
		name: "AlphaWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	keyringpro: {
		brand: {
			alt: "KEYRING PRO Wallet",
			imageId: "dda0f0fb-34e8-4a57-dcea-b008e7d1ff00",
			primaryColor: "#00D2C9"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:128",
			"eip155:137",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:250",
			"eip155:256",
			"eip155:4002",
			"eip155:42",
			"eip155:42161",
			"eip155:421611",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:61",
			"eip155:69",
			"eip155:80001",
			"eip155:88",
			"eip155:97"
		],
		mobile: {
			androidId: "co.bacoor.keyring",
			iosId: "id1546824976",
			native: "keyring://wc",
			universal: "https://keyring.app/wc"
		},
		name: "KEYRING PRO",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	lobstr: {
		brand: {
			alt: "LOBSTR Wallet",
			imageId: "0dafcaab-0852-47f7-85dd-436b86491d00"
		},
		chains: [
			"stellar:pubnet"
		],
		mobile: {
			androidId: "com.lobstr.client",
			iosId: "id1404357892",
			native: "lobstr://wc",
			universal: "https://lobstr.co/uni/wc"
		},
		name: "LOBSTR Wallet",
		shortName: "LOBSTR",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	onto: {
		brand: {
			alt: "ONTO Wallet",
			imageId: "d22b2a4b-5562-49ba-506b-6d5986914600",
			primaryColor: "#ffffff"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1024",
			"eip155:128",
			"eip155:1280",
			"eip155:1284",
			"eip155:1313161554",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:1666600003",
			"eip155:288",
			"eip155:42161",
			"eip155:4689",
			"eip155:50",
			"eip155:56",
			"eip155:58",
			"eip155:66",
			"neo3:mainnet",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.github.ontio.onto",
			iosId: "id1436009823",
			native: "ontoprovider://wc"
		},
		name: "ONTO",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	mathwallet: {
		brand: {
			alt: "MathWallet Wallet",
			imageId: "26a8f588-3231-4411-60ce-5bb6b805a700"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"cosmos:irishub-1",
			"cosmos:kava-4",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1024",
			"eip155:1139",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:1666600000",
			"eip155:288",
			"eip155:30",
			"eip155:321",
			"eip155:336",
			"eip155:40",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:44",
			"eip155:4689",
			"eip155:50",
			"eip155:52",
			"eip155:56",
			"eip155:59",
			"eip155:61",
			"eip155:66",
			"eip155:686",
			"eip155:787",
			"eip155:86",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "afbcbjpbpfadlkmhmclhkeeodmamcflc",
			edgeId: "dfeccadlilpndjjohbjdblepmjeahlmm"
		},
		mobile: {
			androidId: "com.mathwallet.android",
			iosId: "id1582612388",
			native: "mathwallet://wc"
		},
		name: "MathWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	unstoppable: {
		brand: {
			alt: "Unstoppable Wallet",
			imageId: "4725dda0-4471-4d0f-7adf-6bbe8b929c00",
			primaryColor: "#0D67FE"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.unstoppabledomains.manager",
			iosId: "id1544748602",
			native: "unstoppabledomains://wc",
			universal: "https://unstoppable.money/wc"
		},
		name: "Unstoppable Domains",
		shortName: "Unstoppable",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	obvious: {
		brand: {
			alt: "Obvious Wallet",
			imageId: "fe1b9394-55af-4828-a70d-5c5b7de6b200",
			primaryColor: "#7FEABD"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:106",
			"eip155:122",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:9000"
		],
		mobile: {
			androidId: "com.hashhalli.obvious",
			iosId: "id1643088398",
			native: "obvious://wc"
		},
		name: "Obvious",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	fireblocks: {
		brand: {
			alt: "Fireblocks Wallet",
			imageId: "7e1514ba-932d-415d-1bdb-bccb6c2cbc00"
		},
		chains: [
			"cosmos:columbus-4",
			"eip155:1",
			"eip155:10",
			"eip155:10000",
			"eip155:10001",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:19",
			"eip155:250",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:4",
			"eip155:42",
			"eip155:42161",
			"eip155:421611",
			"eip155:42220",
			"eip155:43113",
			"eip155:43114",
			"eip155:44787",
			"eip155:5",
			"eip155:50",
			"eip155:51",
			"eip155:56",
			"eip155:59",
			"eip155:61",
			"eip155:62320",
			"eip155:63",
			"eip155:69",
			"eip155:97",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		desktop: {
			native: "fireblocks-wc://wc",
			universal: "https://console.fireblocks.io/v2/"
		},
		mobile: {
			androidId: "com.fireblocks.client",
			iosId: "id1439296596",
			native: "fireblocks-wc://wc"
		},
		name: "Fireblocks",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	ambire: {
		brand: {
			alt: "Ambire Wallet",
			imageId: "c39b3a16-1a38-4588-f089-cb7aeb584700",
			primaryColor: "#aa6aff"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			native: "ambire://wc",
			universal: "https://wallet.ambire.com"
		},
		mobile: {
			androidId: "com.ambire.wallet",
			iosId: "id6444863857",
			native: "ambire://wc",
			universal: "https://mobile.ambire.com/wc"
		},
		name: "Ambire Wallet",
		shortName: "Ambire",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	infinitywallet: {
		brand: {
			alt: "Infinity Wallet Wallet",
			imageId: "9f259366-0bcd-4817-0af9-f78773e41900",
			primaryColor: "#197fe1"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:1666600003",
			"eip155:25",
			"eip155:321",
			"eip155:43114",
			"eip155:50",
			"eip155:56",
			"eip155:66",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			native: "infinity://wc",
			universal: "https://infinitywallet.io/"
		},
		name: "Infinity Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	bridgewallet: {
		brand: {
			alt: "BridgeWallet Wallet",
			imageId: "20c3072e-c92e-4902-d4b9-cb2b6ab29100",
			primaryColor: "#4ec9fa"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:250",
			"eip155:30",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.mtpelerin.bridge",
			iosId: "id1481859680",
			universal: "https://bridge.mtpelerin.com/wc"
		},
		name: "Bridge Wallet",
		shortName: "BridgeWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	internetmoney: {
		brand: {
			alt: "InternetMoney Wallet",
			imageId: "204b2240-5ce4-4996-6ec4-f06a22726900",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:106",
			"eip155:1285",
			"eip155:25",
			"eip155:3",
			"eip155:338",
			"eip155:4",
			"eip155:4002",
			"eip155:42",
			"eip155:420",
			"eip155:42161",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:6",
			"eip155:61",
			"eip155:62",
			"eip155:63",
			"eip155:80001",
			"eip155:940",
			"eip155:97"
		],
		desktop: {
			chromeId: "ckklhkaabbmdjkahiaaplikpdddkenic",
			universal: "https://internetmoney.io"
		},
		mobile: {
			androidId: "com.internetmoneywallet.app",
			iosId: "id1641771042",
			native: "internetmoney://wc",
			universal: "https://internetmoney.io/wc"
		},
		name: "Internet Money Wallet",
		shortName: "InternetMoney",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	nowwallet: {
		brand: {
			alt: "NOW Wallet Wallet",
			imageId: "b6ee4efc-f53e-475b-927b-a7ded6211700",
			primaryColor: "#00C26F"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			native: "walletnow://wc",
			universal: "https://walletnow.app.link"
		},
		mobile: {
			androidId: "com.nowwallet",
			iosId: "id1591216386",
			native: "walletnow://wc",
			universal: "https://walletnow.app.link/wc"
		},
		name: "NOW Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	bitcoincomwallet: {
		brand: {
			alt: "Bitcoin.com Wallet Wallet",
			imageId: "0d7938e1-9b3b-4d8b-177b-98188c4cf400",
			primaryColor: "#0AC18E"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.bitcoin.mwallet",
			iosId: "id1252903728",
			native: "bitcoincom://wc",
			universal: "https://wallet.bitcoin.com/wc"
		},
		name: "Bitcoin.com Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	uwallet: {
		brand: {
			alt: "αU wallet Wallet",
			imageId: "58a5b183-4d44-4cdd-22da-e89f49fa4c00",
			primaryColor: "#784296"
		},
		chains: [
			"eip155:137"
		],
		mobile: {
			androidId: "com.kddi.wallet",
			iosId: "id6444401106",
			universal: "https://alphauwallet.page.link/wc"
		},
		name: "αU wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	coin98: {
		brand: {
			alt: "Coin98 Wallet",
			imageId: "fc460647-ea95-447a-99f0-1bff8fa4be00",
			primaryColor: "#CDA349"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:122",
			"eip155:128",
			"eip155:1284",
			"eip155:1313161554",
			"eip155:1666600000",
			"eip155:199",
			"eip155:200",
			"eip155:25",
			"eip155:250",
			"eip155:288",
			"eip155:321",
			"eip155:324",
			"eip155:361",
			"eip155:42161",
			"eip155:56",
			"eip155:61",
			"eip155:66",
			"eip155:86",
			"eip155:88",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "aeachknmefphepccionboohckonoeemg"
		},
		mobile: {
			androidId: "coin98.crypto.finance.media",
			iosId: "id1561969966",
			native: "coin98://wc",
			universal: "https://coin98.com/wc"
		},
		name: "Coin98 Super App",
		shortName: "Coin98",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	abcwallet: {
		brand: {
			alt: "ABC Wallet Wallet",
			imageId: "f9854c79-14ba-4987-42e1-4a82abbf5700",
			primaryColor: "#04B4BF"
		},
		chains: [
			"eip155:1",
			"eip155:1001",
			"eip155:137",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:8217",
			"eip155:97"
		],
		mobile: {
			androidId: "io.myabcwallet.mpc",
			iosId: "id1642837445",
			native: "abc-wallet://wc",
			universal: "https://abcwalletconnect.page.link/wc"
		},
		name: "ABC Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	ottr: {
		brand: {
			alt: "Ottr Wallet",
			imageId: "7025146c-c341-473f-a79c-62ec48eef800"
		},
		chains: [
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "finance.ottr.android",
			iosId: "id1628669270",
			universal: "https://links.ottr.finance/wc"
		},
		name: "Ottr Finance",
		shortName: "Ottr",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	arculuswallet: {
		brand: {
			alt: "Arculus Wallet Wallet",
			imageId: "f78dab27-7165-4a3d-fdb1-fcff06c0a700"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "co.arculus.wallet.android",
			iosId: "id1575425801",
			native: "arculuswc://wc"
		},
		name: "Arculus Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	operacryptobrowser: {
		brand: {
			alt: "Opera Crypto Browser Wallet",
			imageId: "877fa1a4-304d-4d45-ca8e-f76d1a556f00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:3",
			"eip155:4",
			"eip155:42",
			"eip155:56"
		],
		mobile: {
			iosId: "id1604311726",
			native: "cryptobrowser://wc"
		},
		name: "Opera Crypto Browser",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	cobalt: {
		brand: {
			alt: "Cobalt Wallet",
			imageId: "29d914e5-9daa-4342-33cd-169155c5a600"
		},
		chains: [
			"eip155:3",
			"eip155:4",
			"eip155:5"
		],
		name: "Cobalt Wallet",
		shortName: "Cobalt",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	chain: {
		brand: {
			alt: "Chain Wallet",
			imageId: "f9f3d8da-e791-47d2-98c2-031712617e00"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			iosId: "id6444779277",
			native: "chainapp://wc"
		},
		name: "Chain",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	huddln: {
		brand: {
			alt: "Huddln Wallet",
			imageId: "7ba1571c-10c4-4284-b438-04dac27cb700",
			primaryColor: "#C6C7FF"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.huddln",
			iosId: "id1503825604",
			native: "huddln://wc"
		},
		name: "Huddln",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	verso: {
		brand: {
			alt: "Verso Wallet",
			imageId: "109d7c90-86ed-4ee0-e17d-3c87624ddf00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.btuprotocol.btu_wallet",
			iosId: "id1539304605",
			native: "verso://wc"
		},
		name: "Verso",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	jadewallet: {
		brand: {
			alt: "Jade Wallet Wallet",
			imageId: "280cd57b-24f4-4700-8d53-94fe292fab00"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			android: "",
			iosId: "id1544207492"
		},
		name: "Jade Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	haha: {
		brand: {
			alt: "HaHa Wallet",
			imageId: "79285c9f-2630-451e-0680-c71b42fb7400",
			primaryColor: "#6B46D2"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.permutize.haha",
			iosId: "id1591158244",
			native: "haha://wc",
			universal: "https://haha.me/wc"
		},
		name: "HaHa",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	modular: {
		brand: {
			alt: "Modular Wallet",
			imageId: "70485da2-2568-463d-722c-25082997cc00",
			primaryColor: "#17171A"
		},
		chains: [
			"eip155:42161"
		],
		mobile: {
			androidId: "com.modular",
			ios: "https://testflight.apple.com/join/Zbf6wZaP",
			native: "modularwallet://wc"
		},
		name: "Modular Wallet Prod",
		shortName: "Modular",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	kelp: {
		brand: {
			alt: "Kelp Wallet",
			imageId: "02d9143d-deed-4336-0cae-f4b8b1091f00",
			primaryColor: "#1CC46C"
		},
		chains: [
			"eip155:56"
		],
		mobile: {
			iosId: "id1632857274",
			native: "link.kelp.finance://wc",
			universal: "https://link.kelp.finance/walletconnect/wc"
		},
		name: "Kelp",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	numio: {
		brand: {
			alt: "Numio Wallet",
			imageId: "416ee463-6699-43f7-c0e3-396f0ad3d300",
			primaryColor: "#222222"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.numio.pay",
			iosId: "id1538072952"
		},
		name: "Numio",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	clingwallet: {
		brand: {
			alt: "Cling Wallet Wallet",
			imageId: "2d8006c3-852b-458a-d6b0-916c5ba76800"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43113",
			"eip155:43114",
			"eip155:71393"
		],
		desktop: {
			chromeId: "kppgpfphbmbcgeglphjnhnhibonmebkn"
		},
		mobile: {
			androidId: "com.carrieverse.cling.wallet",
			iosId: "id6443952504",
			native: "://wc",
			universal: "https://cling.carrieverse.com/apple-app-site-association/wc"
		},
		name: "Cling Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	broearn: {
		brand: {
			alt: "Broearn Wallet",
			imageId: "b3c2c77c-a8cf-46e1-095a-77f0a3891500",
			primaryColor: "#6322F2"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:128",
			"eip155:137",
			"eip155:250",
			"eip155:256",
			"eip155:4002",
			"eip155:420",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:6",
			"eip155:61",
			"eip155:65",
			"eip155:66",
			"eip155:80001",
			"eip155:97",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		mobile: {
			androidId: "com.broearn.browser",
			iosId: "id6444156587",
			native: "broearn://wc"
		},
		name: "Broearn",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	mysabay: {
		brand: {
			alt: "MySabay Wallet",
			imageId: "c4df7014-abaf-4016-8180-fb994804b400"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "kh.com.sabay.sabaywallet",
			iosId: "id6449341309",
			native: "myApp://wc"
		},
		name: "Sabay Wallet App",
		shortName: "MySabay",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	coinomi: {
		brand: {
			alt: "Coinomi Wallet",
			imageId: "3b446d16-a908-40c8-5835-9a6efe90dd00"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.coinomi.wallet",
			iosId: "id1333588809",
			native: "coinomi://wc",
			universal: "https://coinomi.page.link/wc"
		},
		name: "Coinomi",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	ripiowallet: {
		brand: {
			alt: "Ripio Wallet Wallet",
			imageId: "fd56c695-ce58-4df5-1625-767571c80700",
			primaryColor: "#64FFB5"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		desktop: {
			chromeId: "ddamhapapianibkkkcclabgicmpnpdnj"
		},
		mobile: {
			androidId: "com.ripio.android",
			iosId: "id1221006761",
			native: "ripio://wc"
		},
		name: "Ripio Portal",
		shortName: "Ripio Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	mytwallet: {
		brand: {
			alt: "My-T Wallet Wallet",
			imageId: "88a2518c-16c2-4ee3-4699-1a1c6903bc00"
		},
		chains: [
			"eip155:1",
			"eip155:5",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			androidId: "com.tokoin.wallet",
			iosId: "id1489276175",
			native: "mtwallet://wc"
		},
		name: "Tokoin | My-T Wallet",
		shortName: "My-T Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	impersonator: {
		brand: {
			alt: "Impersonator Wallet",
			imageId: "b072a0c6-1bc2-4a80-6f05-50a4ebbf0700"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:200",
			"eip155:250",
			"eip155:4002",
			"eip155:420",
			"eip155:42161",
			"eip155:421611",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:69",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			chromeId: "hgihfkmoibhccfdohjdbklmmcknjjmgl"
		},
		name: "Impersonator",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	fncywallet: {
		brand: {
			alt: "Fncy Wallet Wallet",
			imageId: "c1c8d374-dff3-419c-96af-3515d0192100"
		},
		chains: [
			"eip155:1",
			"eip155:5",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			androidId: "com.metaverse.world.cube",
			iosId: "id1613707166",
			native: "metaCubeWallet://wc"
		},
		name: "Fncy Mobile Wallet",
		shortName: "Fncy Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	copiosa: {
		brand: {
			alt: "Copiosa Wallet",
			imageId: "cae1be94-9f53-4eba-b915-f6e381d5a500",
			primaryColor: "#4564FD"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "io.copiosa.exchange",
			iosId: "id6443951470",
			native: "copiosa://wc",
			universal: "https://copiosa.io/action/wc"
		},
		name: "Copiosa",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	openbisea: {
		brand: {
			alt: "OpenBiSea Wallet",
			imageId: "bc1e1eab-51e6-4a9c-9923-50ad934c3c00"
		},
		chains: [
			"eip155:1",
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:137",
			"eip155:56",
			"eip155:97",
			"near:mainnet",
			"near:testnet"
		],
		name: "OpenBiSea",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	imota: {
		brand: {
			alt: "Imota Wallet",
			imageId: "c81f5bbf-ce66-42bd-3436-f1baaaa18b00",
			primaryColor: "#68DEBB"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:66"
		],
		mobile: {
			androidId: "com.nft5.imota",
			iosId: "id6444327204"
		},
		name: "Imota ",
		shortName: "Imota",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	libera: {
		brand: {
			alt: "Libera Wallet",
			imageId: "9485d17f-c413-47fe-ebee-a876a9dc9100",
			primaryColor: "#2362FB"
		},
		chains: [
			"eip155:42220"
		],
		mobile: {
			androidId: "com.impactmarket.mobile",
			ios: "",
			native: "libera://wc"
		},
		name: "Libera",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	certhis: {
		brand: {
			alt: "Certhis Wallet",
			imageId: "fbd441cc-e861-46dc-48ae-a04228ddb500",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			universal: "https://certhis.io"
		},
		mobile: {
			android: "",
			ios: "",
			universal: "https://certhis.io/wc"
		},
		name: "Certhis",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	burritowallet: {
		brand: {
			alt: "Burrito Wallet Wallet",
			imageId: "7eec7187-3f48-4fda-53bb-b0ad55749a00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"eip155:8217",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.burritowallet.app",
			ios: "",
			native: "burrito://wc"
		},
		name: "Burrito Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ancrypto: {
		brand: {
			alt: "Ancrypto Wallet",
			imageId: "18e6f5c7-381d-497f-fa25-fa1d24928e00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.ancryptoWallet",
			native: "ancrypto://wc"
		},
		name: "Ancrypto",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	llamanodes: {
		brand: {
			alt: "LlamaNodes Wallet",
			imageId: "e0239d64-ded7-4475-64f9-db9671318a00",
			primaryColor: "#F56284"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		name: "LlamaNodes",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cypherock: {
		brand: {
			alt: "Cypherock Wallet",
			imageId: "7fd5a23a-3a01-4cfb-3c8b-9f43ae414400"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:1666600000",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:61"
		],
		desktop: {
			native: "cypherock://wc"
		},
		name: "Cypherock cySync",
		shortName: "Cypherock",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cvlwallet: {
		brand: {
			alt: "CVL Wallet Wallet",
			imageId: "e4eff15a-35d5-49fe-047f-33e331f46400",
			primaryColor: "#48F2BB"
		},
		chains: [
			"eip155:1",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "llp.bc_group.cvl_wallet",
			iosId: "id6444357628",
			universal: "https://app.cvl.network/wc"
		},
		name: "CVL Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cypherwallet: {
		brand: {
			alt: "Cypher Wallet Wallet",
			imageId: "7bce0965-a4cc-4aad-6217-009d51017500",
			primaryColor: "#FFDE59"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.cypherd.androidwallet",
			ios: "",
			native: "cypherwallet://wc"
		},
		name: "Cypher Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	status: {
		brand: {
			alt: "Status Wallet",
			imageId: "e131fa98-8c4f-4680-f5b6-6fb77189c900",
			primaryColor: "#4360df"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:3",
			"eip155:4"
		],
		mobile: {
			androidId: "im.status.ethereum",
			iosId: "id1178893006"
		},
		name: "Status",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	enjinwallet: {
		brand: {
			alt: "Enjin Wallet Wallet",
			imageId: "add9626b-a5fa-4c12-178c-e5584e6dcd00",
			primaryColor: "#7567CE"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182"
		],
		mobile: {
			androidId: "com.enjin.mobile.wallet",
			iosId: "id1349078375",
			native: "enjinwallet://wc",
			universal: "https://deeplink.wallet.enjin.io/wc"
		},
		name: "Enjin Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	essentials: {
		brand: {
			alt: "Essentials Wallet",
			imageId: "058878f4-7364-4e01-434f-2cc09a15cf00"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:122",
			"eip155:128",
			"eip155:137",
			"eip155:170",
			"eip155:20",
			"eip155:22",
			"eip155:23",
			"eip155:25",
			"eip155:256",
			"eip155:32659",
			"eip155:338",
			"eip155:40",
			"eip155:4002",
			"eip155:41",
			"eip155:42161",
			"eip155:421611",
			"eip155:43113",
			"eip155:43114",
			"eip155:4689",
			"eip155:4690",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:9000",
			"eip155:97"
		],
		mobile: {
			androidId: "org.elastos.essentials.app",
			iosId: "id1568931743",
			universal: "https://essentials.web3essentials.io/wc"
		},
		name: "Essentials",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	everspace: {
		brand: {
			alt: "everspace Wallet",
			imageId: "80eaa630-6392-4b0a-a604-0a0f808e4d00"
		},
		chains: [
			"tvm:42"
		],
		mobile: {
			androidId: "com.oberton.app",
			iosId: "id1585434994",
			native: "everspace://wc"
		},
		name: "Everspace",
		shortName: "everspace",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	blockwallet: {
		brand: {
			alt: "BlockWallet Wallet",
			imageId: "ef825629-9828-4a5a-b376-62ab4ee81f00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:200",
			"eip155:250",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:4",
			"eip155:4002",
			"eip155:420",
			"eip155:42161",
			"eip155:421611",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:69",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			chromeId: "bopcbmipnjdcdfflfgjdgdjejmgpoaab"
		},
		name: "BlockWallet"
	},
	kriptomat: {
		brand: {
			alt: "Kriptomat Wallet",
			imageId: "774110aa-70f6-4d0c-210f-ab434838fa00",
			primaryColor: "#6E52FF"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "io.kriptomat.app",
			iosId: "id1440135740",
			native: "kriptomatapp://wc"
		},
		name: "Kriptomat",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	oxalus: {
		brand: {
			alt: "Oxalus Wallet",
			imageId: "a6e22fcb-6b69-45d2-b52d-a4a347a21e00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42",
			"eip155:43113",
			"eip155:43114",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "io.oxalus.wallet",
			iosId: "id1620111723",
			native: "oxalus://wc",
			universal: "https://oxalus.page.link/wc"
		},
		name: "Oxalus Wallet",
		shortName: "Oxalus",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	metatracegift: {
		brand: {
			alt: "MetaTraceGift Wallet",
			imageId: "916c8480-a52d-4f4c-82b5-47cac8c84300"
		},
		chains: [
			"eip155:137"
		],
		name: "trace-gift",
		shortName: "MetaTraceGift",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	thetawallet: {
		brand: {
			alt: "Theta Wallet Wallet",
			imageId: "d4afb810-5925-4f00-4ebb-d180fcf29000"
		},
		chains: [
			"eip155:361",
			"eip155:363",
			"eip155:364",
			"eip155:365"
		],
		mobile: {
			androidId: "org.theta.wallet",
			iosId: "id1451094550",
			native: "wc://wc"
		},
		name: "Theta Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	dawn: {
		brand: {
			alt: "Dawn Wallet",
			spriteId: "dawn"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161"
		],
		mobile: {
			iosId: "id1673143782"
		},
		name: "Dawn",
		shortName: "Dawn"
	},
	rabby: {
		brand: {
			alt: "Rabby Wallet",
			imageId: "255e6ba2-8dfd-43ad-e88e-57cbb98f6800"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:250",
			"eip155:30",
			"eip155:40",
			"eip155:42161",
			"eip155:42220",
			"eip155:56",
			"eip155:66",
			"eip155:888"
		],
		desktop: {
			chromeId: "acmacodkjbdgmoleebolmdjonilkdbch"
		},
		name: "Rabby",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	gearbox: {
		brand: {
			alt: "Gearbox Wallet",
			imageId: "d753e026-3756-4770-e43d-2d080d6f7800"
		},
		chains: [
			"eip155:1",
			"eip155:5"
		],
		name: "Gearbox Client",
		shortName: "Gearbox",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	leapcosmos: {
		brand: {
			alt: "Leap Cosmos Wallet",
			imageId: "73e6b2b2-8c02-42e9-84f5-82a859978200"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"cosmos:irishub-1"
		],
		desktop: {
			chromeId: "fcfcfllfndlomdhbehjjcoimbgofdncg"
		},
		mobile: {
			androidId: "io.leapwallet.cosmos",
			iosId: "id1642465549",
			native: "leapcosmos://wc"
		},
		name: "Leap Cosmos Wallet",
		shortName: "Leap Cosmos",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	islami: {
		brand: {
			alt: "ISLAMI Wallet",
			imageId: "8d723c78-28ad-4610-901f-ea391d7e8d00",
			primaryColor: "#24262E"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.islami.wallet",
			iosId: "id1631212925",
			native: "islamiwallet://wc"
		},
		name: "ISLAMIwallet",
		shortName: "ISLAMI",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	upbondwallet: {
		brand: {
			alt: "UPBOND Wallet Wallet",
			imageId: "698e08f3-b452-4c91-9f65-299939396a00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:420",
			"eip155:80001"
		],
		name: "UPBOND Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	vivewallet: {
		brand: {
			alt: "VIVE Wallet Wallet",
			imageId: "5ef7e40e-1f02-4da2-54bf-992e3e83e100"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.htc.vivewallet",
			iosId: "id6444718696"
		},
		name: "VIVE Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	wirexwallet: {
		brand: {
			alt: "Wirex Wallet Wallet",
			imageId: "66b40d9b-7314-42dd-cacf-4e324b0c2000",
			primaryColor: "#C9FFC6"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"stellar:pubnet"
		],
		mobile: {
			androidId: "com.wirex.wallet",
			iosId: "id1594165139",
			native: "wirexwallet://wc",
			universal: "https://wwallet.app.link/wc"
		},
		name: "Wirex Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mask: {
		brand: {
			alt: "Mask Wallet",
			imageId: "51fa27fd-8a21-4de0-c084-528e4a37ad00",
			primaryColor: "#1c67f2"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:137",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "com.dimension.maskbook",
			iosId: "id1478382964"
		},
		name: "Mask Network",
		shortName: "Mask",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	bcertinwallet: {
		brand: {
			alt: "BCERTin wallet Wallet",
			imageId: "e321346d-5ce7-4e75-371e-e4f0bf923900",
			primaryColor: "#76b53b"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:3",
			"eip155:4",
			"eip155:5"
		],
		mobile: {
			androidId: "com.blockcerts.BlockCerts"
		},
		name: "BCERTin wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	monarch: {
		brand: {
			alt: "Monarch Wallet",
			imageId: "c664d955-8a1e-4460-3917-4cfcf198f000",
			primaryColor: "#F9A900"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			iosId: "id1386397997"
		},
		name: "Monarch Wallet",
		shortName: "Monarch",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	filwallet: {
		brand: {
			alt: "FILWallet Wallet",
			imageId: "f400f6c2-ca6c-487b-654d-e119af247500"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			android: "https://filwallet.co/",
			iosId: "id1572930901",
			universal: "https://h5.filwallet.co/wc"
		},
		name: "FILWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	vision: {
		brand: {
			alt: "Vision Wallet",
			imageId: "64ccf07c-1fba-4473-49e8-dc446e5a5000",
			primaryColor: "#0b121c"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.eletac.tronwallet",
			iosId: "id1500186931",
			native: "visionwallet://wc",
			universal: "https://app.vision-crypto.com/wc"
		},
		name: "Vision: Crypto Wallet",
		shortName: "Vision",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	valora: {
		brand: {
			alt: "Valora Wallet",
			imageId: "a03bfa44-ce98-4883-9b2a-75e2b68f5700",
			primaryColor: "#42D689"
		},
		chains: [
			"eip155:42220"
		],
		mobile: {
			androidId: "co.clabs.valora",
			iosId: "id1520414263",
			native: "celo://wc",
			universal: "https://valoraapp.com/wc"
		},
		name: "Valora",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	coincircle: {
		brand: {
			alt: "CoinCircle Wallet",
			imageId: "eae63a23-c7ba-4f7e-24b3-e6fc69215d00",
			primaryColor: "#2499c4"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			android: "https://coincircle.com/app",
			ios: "https://coincircle.com/app",
			universal: "https://coincircle.com/app/walletconnect/wc"
		},
		name: "CoinCircle",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	mywallid: {
		brand: {
			alt: "MyWalliD Wallet",
			imageId: "e6cff623-9671-4a39-acc7-1c2292d7e100",
			primaryColor: "#009FB1"
		},
		chains: [
			"eip155:1"
		],
		desktop: {
			chromeId: "eknlkogikcabnjbjnhmjllabckeapdii"
		},
		name: "MyWalliD",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	brisewallet: {
		brand: {
			alt: "BRISE Wallet Wallet",
			imageId: "09a4e1d9-e4de-44fa-f248-5495ba9ab300"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.brise.wallet"
		},
		name: "BRISE Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	snowball: {
		brand: {
			alt: "Snowball Wallet",
			imageId: "313faea4-af8c-41f4-0ed8-98be5d048e00",
			primaryColor: "#292E39"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "money.snowball.defi",
			iosId: "id1449662311"
		},
		name: "Snowball",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	gamestopwallet: {
		brand: {
			alt: "GameStop Wallet Wallet",
			imageId: "c12536e0-dff1-4a1a-6c8f-c7247d6aa200",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			ios: "https://wallet.gamestop.com/wallets"
		},
		name: "GameStop Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	paraswap: {
		brand: {
			alt: "ParaSwap Wallet",
			imageId: "73dc6b30-b644-46e6-020c-5926851df600",
			primaryColor: "#2669F5"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			iosId: "id1584610690",
			native: "paraswap://wc"
		},
		name: "ParaSwap Wallet",
		shortName: "ParaSwap",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	balletcrypto: {
		brand: {
			alt: "Ballet Crypto Wallet",
			imageId: "542094e6-70d6-4b0d-4c8f-b61cc2c38500"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.balletcrypto",
			iosId: "id1474912942"
		},
		name: "Ballet Crypto",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	uvtoken: {
		brand: {
			alt: "UvToken Wallet",
			imageId: "a0057241-cd91-4a53-7175-016b76bfd900"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:56",
			"eip155:65",
			"eip155:66",
			"eip155:97",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182"
		],
		mobile: {
			android: "https://wallet.uvtoken.com/static/download/android/uvtoken.apk",
			iosId: "id1552556395"
		},
		name: "UvToken",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	theparallel: {
		brand: {
			alt: "TheParallel Wallet",
			imageId: "de73fe0b-0244-4373-dea4-bef78ca82e00"
		},
		chains: [
			"eip155:56",
			"eip155:97"
		],
		name: "The Parallel",
		shortName: "TheParallel",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	realtwallet: {
		brand: {
			alt: "RealT Wallet Wallet",
			imageId: "bf1f251b-08a5-4b27-ae4a-201a5f698900"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:3",
			"eip155:4",
			"eip155:5"
		],
		mobile: {
			androidId: "co.realt.bridge",
			iosId: "id1545585469"
		},
		name: "RealT Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	sahalwallet: {
		brand: {
			alt: "SahalWallet Wallet",
			imageId: "d29d6426-b6f2-481b-12d8-7b20ec82af00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:4",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "sahal.wallet.app",
			iosId: "id1602366920"
		},
		name: "SahalWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	apollox: {
		brand: {
			alt: "ApolloX Wallet",
			imageId: "80ab63a2-1b32-4140-3577-9fbc8ea82e00"
		},
		chains: [
			"eip155:56"
		],
		desktop: {
			universal: "https://app.apollox.finance"
		},
		mobile: {
			androidId: "com.apollox.android",
			iosId: "id1589405398",
			universal: "https://app.apollox.finance/wc"
		},
		name: "ApolloX",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	ennowallet: {
		brand: {
			alt: "EnnoWallet Wallet",
			imageId: "ae4f5167-0b61-43bd-7d76-1f8579271000"
		},
		chains: [
			"eip155:1",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.app.awqsome.ennowallet",
			iosId: "id1577011660",
			native: "ennowallet://wc"
		},
		name: "Enno Wallet",
		shortName: "EnnoWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	nitrogen: {
		brand: {
			alt: "Nitrogen Wallet",
			imageId: "af185895-cda5-4eaf-e31b-28b6fe4b0800"
		},
		chains: [
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		mobile: {
			androidId: "org.nitrogen.mobile_wallet",
			iosId: "id1595123469"
		},
		name: "Nitrogen Wallet",
		shortName: "Nitrogen",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	loopringwallet: {
		brand: {
			alt: "Loopring Wallet Wallet",
			imageId: "2103feda-4fc8-4635-76a7-02a4ed998000"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			android: "",
			iosId: "id1550921126",
			native: "loopring://wc"
		},
		name: "Loopring Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	a4wallet: {
		brand: {
			alt: "A4 Wallet Wallet",
			imageId: "7a788c03-daf7-4d93-fa3a-f94e2b719900"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			androidId: "finance.a4.mobile",
			iosId: "id1623005090"
		},
		name: "A4 Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	beewallet: {
		brand: {
			alt: "BeeWallet Wallet",
			imageId: "ae53ba0b-4d01-42f6-53d8-cc568409b700",
			primaryColor: "#ffc04d"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "network.bee.app",
			iosId: "id1529988919"
		},
		name: "BeeWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	bobamultisig: {
		brand: {
			alt: "Boba Multisig Wallet",
			imageId: "5acb31bf-151e-4ae6-02bd-f109ca47b600"
		},
		chains: [
			"eip155:288"
		],
		name: "Boba Multisig",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	dohrniiwallet: {
		brand: {
			alt: "Dohrnii Wallet Wallet",
			imageId: "1bb51ed9-68ed-4012-3082-72dcb7754300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "io.dohrnii.wallet",
			iosId: "id1624702756"
		},
		name: "Dohrnii Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	localtrade: {
		brand: {
			alt: "LocalTrade Wallet",
			imageId: "fcc60983-74ae-484a-4242-87cb6f05f100",
			primaryColor: "#00957B"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.localtrade.wallet",
			iosId: "id1602772298"
		},
		name: "LocalTrade Wallet",
		shortName: "LocalTrade",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	xcapit: {
		brand: {
			alt: "Xcapit Wallet",
			imageId: "17f59b75-21b0-4b3f-b024-fe4b9b8d2300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:30",
			"eip155:56"
		],
		mobile: {
			androidId: "com.xcapit.app",
			iosId: "id1545648148",
			universal: "https://app.xcapit.com/links/wc"
		},
		name: "Xcapit",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	bcvault: {
		brand: {
			alt: "BCVault Wallet",
			imageId: "56995d82-a980-4dfc-2611-0f91d88c5700"
		},
		chains: [
			"eip155:1",
			"eip155:106",
			"eip155:128",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			native: "bcvault://wc"
		},
		name: "BCVault",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	safematrix: {
		brand: {
			alt: "Safematrix Wallet",
			imageId: "48ea5de9-869a-4994-2402-97afba060900",
			primaryColor: "#ff3366"
		},
		chains: [
			"eip155:1",
			"eip155:4",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			android: "https://download.safematrix.io/abm/safematrix.apk",
			iosId: "id1613333481",
			universal: "https://safematrix.io/wc"
		},
		name: "Safematrix",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	neonwallet: {
		brand: {
			alt: "Neon Wallet Wallet",
			imageId: "322bd6f0-09b5-4595-cb15-0dfab8054800",
			primaryColor: "#4cffb3"
		},
		chains: [
			"neo3:mainnet"
		],
		mobile: {
			androidId: "neo.org.freewallet.app",
			iosId: "id1530111452"
		},
		name: "Neon Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	absolutewallet: {
		brand: {
			alt: "AbsoluteWallet Wallet",
			imageId: "03797059-fc49-4adc-7b93-503290b62300"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:122",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:1666600000",
			"eip155:199",
			"eip155:25",
			"eip155:250",
			"eip155:321",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:50",
			"eip155:56",
			"eip155:61",
			"eip155:787",
			"eip155:8",
			"eip155:820",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		name: "AbsoluteWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	lockertoken: {
		brand: {
			alt: "LockerToken Wallet",
			imageId: "37401d35-3fa1-451c-802d-604940315800",
			primaryColor: "#9B5AF2"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:30",
			"eip155:31",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.lockertoken",
			iosId: "id1619140841"
		},
		name: "Locker Token",
		shortName: "LockerToken",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	sequence: {
		brand: {
			alt: "Sequence Wallet",
			imageId: "b2d5c39c-a485-4efa-5736-a782204e4a00",
			primaryColor: "#4E47F5"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:4",
			"eip155:42161",
			"eip155:421611",
			"eip155:43113",
			"eip155:43114",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			universal: "https://sequence.app"
		},
		mobile: {
			universal: "https://sequence.app/wc"
		},
		name: "Sequence Wallet",
		shortName: "Sequence",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	linen: {
		brand: {
			alt: "Linen Wallet",
			imageId: "aff3e4e1-92a9-4066-f48f-3591947cf200",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:137",
			"eip155:5",
			"eip155:80001"
		],
		mobile: {
			androidId: "app.linen.wallet",
			iosId: "id1480509067",
			native: "linen://wc",
			universal: "https://linen.app/wc"
		},
		name: "Linen",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	nabox: {
		brand: {
			alt: "Nabox Wallet",
			imageId: "3b75e9f7-2ca8-4a33-ed2b-4e8a0c048d00",
			primaryColor: "#53B8A9"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:1313161554",
			"eip155:4689",
			"eip155:50"
		],
		desktop: {
			chromeId: "nknhiehlklippafakaeklbeglecifhad"
		},
		mobile: {
			androidId: "com.wallet.nabox",
			ios: "https://testflight.apple.com/join/Ux18h5Nv",
			universal: "https://nabox.io/app/*/wc"
		},
		name: "Nabox",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	unipass: {
		brand: {
			alt: "UniPass Wallet",
			imageId: "77865965-4322-4ac4-5049-b2af11bf8300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		desktop: {
			universal: "https://wallet.unipass.id"
		},
		mobile: {
			android: "",
			ios: "",
			universal: "https://wallet.unipass.id/wc"
		},
		name: "UniPass",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	dope: {
		brand: {
			alt: "Dope Wallet",
			imageId: "28069b46-08ce-4fc7-722a-69554445e600"
		},
		chains: [
			"eip155:1",
			"eip155:122",
			"eip155:128",
			"eip155:137",
			"eip155:250",
			"eip155:32659",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.kyriakosalexandrou.coinmarketcap",
			iosId: "id1350234503",
			universal: "https://share.dopamineapp.com/wc"
		},
		name: "DopamineApp",
		shortName: "Dope",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	marble: {
		brand: {
			alt: "Marble Wallet",
			imageId: "eb6de921-6824-4f35-6331-8a8b031e7100",
			primaryColor: "#F24B01"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:3",
			"eip155:4",
			"eip155:420",
			"eip155:5",
			"eip155:6",
			"eip155:69",
			"eip155:80001"
		],
		desktop: {
			universal: "https://app.marblewallet.com/"
		},
		mobile: {
			universal: "https://app.marblewallet.com/wc"
		},
		name: "Marble",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	spatium: {
		brand: {
			alt: "Spatium Wallet",
			imageId: "51867bee-2963-4071-d67a-1fdcaa451f00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "capital.spatium.wallet",
			iosId: "id1404844195"
		},
		name: "Spatium",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	cryptnoxwallet: {
		brand: {
			alt: "Cryptnox Wallet Wallet",
			imageId: "2947b7c8-8966-4485-a98d-25fe43c16700"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			iosId: "id1583011693"
		},
		name: "Cryptnox Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	ownbit: {
		brand: {
			alt: "ownbit Wallet",
			imageId: "19923b08-7208-4539-9c2d-c43db22bce00"
		},
		chains: [
			"eip155:1",
			"eip155:43114",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182"
		],
		mobile: {
			androidId: "com.bitbill.www",
			iosId: "id1321798216"
		},
		name: "Ownbit",
		shortName: "ownbit",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	idpocketdigitalidentitywallet: {
		brand: {
			alt: "ID Pocket digital identity wallet Wallet",
			imageId: "c227ee0a-5127-4707-ded9-c3cd81348d00"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.rktechworks.idpocket",
			iosId: "id1549462128"
		},
		name: "ID Pocket",
		shortName: "ID Pocket digital identity wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	assure: {
		brand: {
			alt: "Assure Wallet",
			imageId: "64db7104-c8b7-44ea-e102-11ce87124200"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182"
		],
		mobile: {
			androidId: "com.neuxs.assure",
			ios: "http://itunes.apple.com/app/id1604825026",
			native: "assure://wc"
		},
		name: "Assure",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	flooz: {
		brand: {
			alt: "Flooz Wallet",
			imageId: "0a04f368-4f56-4c12-0bfa-93b14bb20800",
			primaryColor: "#5E38F4"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		desktop: {
			universal: "https://wallet.flooz.trade/"
		},
		mobile: {
			androidId: "wallet.flooz.mobile",
			iosId: "id1621027074",
			native: "floozwallet://wc",
			universal: "https://wallet.flooz.trade/wc"
		},
		name: "Flooz",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	aton: {
		brand: {
			alt: "ATON Wallet",
			imageId: "2e85f1d1-f498-4cae-bb54-1d40614ee300"
		},
		chains: [
			"eip155:201030",
			"eip155:210309"
		],
		mobile: {
			androidId: "com.platon.aton",
			iosId: "id1473112418"
		},
		name: "ATON",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	keplr: {
		brand: {
			alt: "Keplr Wallet",
			imageId: "527324b0-3849-462b-9a1a-72b53bdfea00",
			primaryColor: "#314FDF"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"cosmos:irishub-1",
			"cosmos:kava-4"
		],
		desktop: {
			chromeId: "dmkamcknogkgcdfhhbddcghachkejeap",
			firefoxId: "keplr"
		},
		mobile: {
			androidId: "com.chainapsis.keplr",
			iosId: "id1567851089"
		},
		name: "Keplr",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	brave: {
		brand: {
			alt: "Brave Wallet",
			imageId: "8cecad66-73e3-46ee-f45f-01503c032f00",
			primaryColor: "#FF2000"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:1313161554",
			"eip155:137",
			"eip155:250",
			"eip155:4",
			"eip155:42220",
			"eip155:44787",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		name: "Brave Wallet",
		shortName: "Brave"
	},
	crossmint: {
		brand: {
			alt: "Crossmint Wallet",
			imageId: "8ad627ec-cbcd-4878-ec5c-3df588055200",
			primaryColor: "#22C392"
		},
		chains: [
			"cip-34:1-764824073",
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			universal: "https://www.crossmint.com"
		},
		mobile: {
			ios: "https://www.crossmint.com"
		},
		name: "Crossmint",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	gryfyn: {
		brand: {
			alt: "Gryfyn Wallet",
			imageId: "51bb1507-45a1-4d21-15f2-1cc2ebe69400",
			primaryColor: "#12ABEC"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		name: "Gryfyn",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	pier: {
		brand: {
			alt: "pier Wallet",
			imageId: "cf3f0da1-40ec-4940-aebe-df075513d100",
			primaryColor: "#221C16"
		},
		chains: [
			"eip155:137",
			"eip155:1666600000",
			"eip155:280",
			"eip155:324",
			"eip155:80001"
		],
		desktop: {
			universal: "https://pierwallet.xyz/wc"
		},
		mobile: {
			androidId: "one.nobank.app",
			iosId: "id1613187762"
		},
		name: "pier",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	core: {
		brand: {
			alt: "Core Wallet",
			imageId: "35f9c46e-cc57-4aa7-315d-e6ccb2a1d600",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:4",
			"eip155:43113",
			"eip155:43114",
			"eip155:5"
		],
		desktop: {
			chromeId: "agoakfejjabomempkjlepdflaleeobhb"
		},
		mobile: {
			androidId: "com.avaxwallet",
			iosId: "id6443685999",
			native: "core://wc",
			universal: "https://core.app/wc"
		},
		name: "Core",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	taho: {
		brand: {
			alt: "Taho Wallet",
			imageId: "13416950-f73f-4a4c-2f22-d494ed5df800"
		},
		chains: [
			"eip155:1",
			"eip155:5"
		],
		desktop: {
			chromeId: "eajafomhmkipbjmfmhebemolkcicgfmd"
		},
		name: "Taho",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	torus: {
		brand: {
			alt: "Torus Wallet",
			imageId: "1caa462e-dcf5-4c56-d180-094c81444f00",
			primaryColor: "#0364ff"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1001",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:30",
			"eip155:31",
			"eip155:420",
			"eip155:42161",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:65",
			"eip155:66",
			"eip155:8217",
			"eip155:97",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		name: "Torus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	keeper: {
		brand: {
			alt: "Keeper Wallet",
			imageId: "41f6ac85-8f4e-4d9f-b37b-92b43fa7f400",
			primaryColor: "#1F5AF6"
		},
		chains: [
			"waves:083",
			"waves:084",
			"waves:087"
		],
		desktop: {
			chromeId: "lpilbniiabackdjcionkobglmddfbcjo"
		},
		mobile: {
			androidId: "app.keeper.wallet",
			iosId: "id6444443920"
		},
		name: "Keeper",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	uniblow: {
		brand: {
			alt: "Uniblow Wallet",
			imageId: "3aa86daa-b885-4686-c443-83355e1b3b00",
			primaryColor: "#6D57FF"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:3",
			"eip155:4",
			"eip155:42",
			"eip155:42161",
			"eip155:421611",
			"eip155:42220",
			"eip155:43113",
			"eip155:43114",
			"eip155:44787",
			"eip155:5",
			"eip155:56",
			"eip155:59",
			"eip155:62320",
			"eip155:80001",
			"eip155:97"
		],
		name: "Uniblow",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	dcent: {
		brand: {
			alt: "D'CENT Wallet",
			imageId: "c68b81d1-a400-4a07-6d9d-28edda986d00"
		},
		chains: [
			"eip155:1",
			"eip155:100",
			"eip155:128",
			"eip155:137",
			"eip155:14",
			"eip155:16",
			"eip155:19",
			"eip155:246",
			"eip155:25",
			"eip155:288",
			"eip155:30",
			"eip155:31",
			"eip155:321",
			"eip155:4",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:5",
			"eip155:50",
			"eip155:56",
			"eip155:66",
			"eip155:8217"
		],
		mobile: {
			androidId: "com.kr.iotrust.dcent.wallet",
			iosId: "id1447206611",
			universal: "https://link.dcentwallet.com/wc"
		},
		name: "D'CENT Wallet",
		shortName: "D'CENT",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	paper: {
		brand: {
			alt: "Paper Wallet",
			imageId: "37d7a10f-d94d-4a56-c30e-267e8afbd500",
			primaryColor: "#6BCDFA"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:420",
			"eip155:5",
			"eip155:80001"
		],
		mobile: {
			android: "",
			ios: "",
			universal: "https://withpaper.com/wc"
		},
		name: "Paper",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	klever: {
		brand: {
			alt: "Klever Wallet",
			imageId: "8f5bbad8-6a14-4b2c-5343-cc1fca6e4d00",
			primaryColor: "#DC3F89"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "cash.klever.blockchain.wallet",
			iosId: "id1525584688",
			native: "kleverwallet://wc",
			universal: "https://klever.page.link/wc"
		},
		name: "Klever Wallet",
		shortName: "Klever",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	edge: {
		brand: {
			alt: "Edge Wallet",
			imageId: "f601bc29-4298-422f-dbf7-34dac2884f00",
			primaryColor: "#66EDA8"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "co.edgesecure.app",
			iosId: "id1344400091",
			native: "edge://wc",
			universal: "https://deep.edge.app/wc"
		},
		name: "Edge Wallet",
		shortName: "Edge",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	neftiwallet: {
		brand: {
			alt: "NeftiWallet Wallet",
			imageId: "1f812dec-be3d-446c-52f7-a79eb0dd5400",
			primaryColor: "#37747E"
		},
		chains: [
			"eip155:56"
		],
		mobile: {
			androidId: "com.NEFTiPEDiA.mp",
			native: "nefti://wc"
		},
		name: "NeftiWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	goldbit: {
		brand: {
			alt: "GoldBit Wallet",
			imageId: "11974ef1-21ab-4806-a2b1-362c31499900"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.goldbitpro.wallet",
			iosId: "id1551914030",
			native: "goldbit://wc"
		},
		name: "GoldBit",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	coingrig: {
		brand: {
			alt: "Coingrig Wallet",
			imageId: "18e38e41-a387-4402-ca31-6d2d5eb91100"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:25",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.coingrig",
			iosId: "id1583464451",
			native: "coingrig://wc",
			universal: "https://link.coingrig.com/wc"
		},
		name: "Coingrig",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	xfunwallet: {
		brand: {
			alt: "XFUN Wallet Wallet",
			imageId: "a665f8f3-09ef-4d17-2bd0-26dca4518400",
			primaryColor: "#FFFFFF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:3",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.xfun.wallet",
			iosId: "id1612225910",
			native: "xfunwallet://wc",
			universal: "https://xfun.io/wc"
		},
		name: "XFUN Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	ricewallet: {
		brand: {
			alt: "RICE Wallet Wallet",
			imageId: "df94578e-19be-4f00-258f-2470343e7b00",
			primaryColor: "#3361f4"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			universal: "https://ricewallet.io"
		},
		mobile: {
			android: "",
			ios: "",
			native: "ricewallet://wc"
		},
		name: "RiceWallet",
		shortName: "RICE Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	ancryptowallet: {
		brand: {
			alt: "Ancrypto Wallet Wallet",
			imageId: "d4382329-e288-4d7a-0ac8-3eb0facfb900"
		},
		chains: [
			"eip155:1",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f"
		],
		mobile: {
			iosId: "id1453657650",
			native: "ancrypto://wc"
		},
		name: "Ancrypto Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	oksewallet: {
		brand: {
			alt: "OkseWallet Wallet",
			imageId: "8a1b36d5-7f40-403a-7000-5d30f9181200",
			primaryColor: "#e51b23"
		},
		chains: [
			"eip155:1",
			"eip155:106",
			"eip155:128",
			"eip155:1313161554",
			"eip155:250",
			"eip155:3",
			"eip155:4",
			"eip155:40",
			"eip155:42",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:88"
		],
		mobile: {
			androidId: "wallet.okse.io",
			iosId: "id1555914591",
			native: "oksewallet://wc"
		},
		name: "Okse Wallet",
		shortName: "OkseWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	aktionariat: {
		brand: {
			alt: "Aktionariat Wallet",
			imageId: "6d18e8ea-b536-4038-c5bf-94a499d5a400",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.aktionariat.app",
			iosId: "id1518326813",
			native: "aktionariat://wc",
			universal: "https://app.aktionariat.com/wc"
		},
		name: "Aktionariat",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	itokenwallet: {
		brand: {
			alt: "iToken Wallet Wallet",
			imageId: "5cd60c34-038d-470c-c024-d58f64260200",
			primaryColor: "#2d67f8"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.huobionchainwallet.gp",
			iosId: "id1433883012",
			native: "huobiwallet://wc"
		},
		name: "iToken Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	zelus: {
		brand: {
			alt: "Zelus Wallet",
			imageId: "aeba2105-6c84-4642-f441-b3f5817ac400"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.zelus.wallet",
			iosId: "id1588430343",
			native: "zeluswallet://wc"
		},
		name: "Zelus",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	talk: {
		brand: {
			alt: "Talk+ Wallet",
			imageId: "d24cdd56-6f55-42da-631b-c25974c36f00",
			primaryColor: "#FCD86C"
		},
		chains: [
			"eip155:1",
			"eip155:4"
		],
		mobile: {
			androidId: "org.talkapp",
			iosId: "id1547227377",
			native: "talkapp://wc"
		},
		name: "Talk+",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	card: {
		brand: {
			alt: "Card Wallet",
			imageId: "325428cf-c212-4d83-a434-7f48902d2c00"
		},
		chains: [
			"eip155:1",
			"eip155:100"
		],
		mobile: {
			android: "https://cardstack.com/android",
			ios: "https://cardstack.com/ios",
			native: "cardwallet://wc",
			universal: "https://wallet.cardstack.com/wc"
		},
		name: "Card Wallet",
		shortName: "Card",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	paybolt: {
		brand: {
			alt: "PayBolt Wallet",
			imageId: "cc8f4e0c-56a8-465a-6cb6-3e9d60846500",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.fincrypt.paybolt",
			iosId: "id1599880290",
			native: "paybolt://wc"
		},
		name: "PayBolt",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	latokendefi: {
		brand: {
			alt: "LATOKEN DeFi Wallet",
			imageId: "ff858a37-cbcb-413d-c1ed-917a444bea00",
			primaryColor: "#5661FF"
		},
		chains: [
			"cosmos:columbus-4",
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.app.defi",
			iosId: "id1614389764",
			native: "dfwallet://wc"
		},
		name: "LATOKEN Multichain DeFi Wallet",
		shortName: "LATOKEN DeFi",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	arianeewallet: {
		brand: {
			alt: "Arianee Wallet Wallet",
			imageId: "13b7fe36-909a-4c83-4f06-5740829a3900"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:77",
			"eip155:80001",
			"eip155:99"
		],
		mobile: {
			androidId: "com.arianee.wallet",
			iosId: "id1435782507",
			native: "com.arianee.wallet://wc",
			universal: "https://arianee.net/wc"
		},
		name: "Arianee Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	slaviwallet: {
		brand: {
			alt: "Slavi Wallet Wallet",
			imageId: "282ce060-0beb-4236-b7b0-1b34cc6c8f00",
			primaryColor: "#F2C75B"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.defiwalletmobile",
			iosId: "id1610125496",
			native: "slaviwallet://wc",
			universal: "https://www.slaviwallet.io/wc"
		},
		name: "Slavi Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	plasmawallet: {
		brand: {
			alt: "Plasma Wallet Wallet",
			imageId: "c268e78d-ffb0-4c8b-5cad-04c3add48500"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:25",
			"eip155:250",
			"eip155:28",
			"eip155:288",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:66"
		],
		mobile: {
			iosId: "id1461735396",
			native: "plasmawallet://wc"
		},
		name: "Plasma Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	iopay: {
		brand: {
			alt: "ioPay Wallet",
			imageId: "18891f5a-fd0f-4126-7d1a-452be6714700",
			primaryColor: "#617AFF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:42",
			"eip155:42161",
			"eip155:4689",
			"eip155:4690",
			"eip155:56"
		],
		mobile: {
			androidId: "io.iotex.iopay.gp",
			iosId: "id1478086371",
			native: "iopay://wc"
		},
		name: "ioPay",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	defiant: {
		brand: {
			alt: "Defiant Wallet",
			imageId: "11a96ca4-3592-42ae-c781-2b7265ec9200",
			primaryColor: "#00bd57"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:250",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:4002",
			"eip155:42",
			"eip155:42161",
			"eip155:421611",
			"eip155:42220",
			"eip155:43113",
			"eip155:43114",
			"eip155:44787",
			"eip155:56",
			"eip155:69",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "ar.com.andinasmart.defiant",
			iosId: "id1559622756",
			native: "defiantapp://wc",
			universal: "https://defiantapp.tech/wc"
		},
		name: "Defiant",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	easy: {
		brand: {
			alt: "EASY Wallet",
			imageId: "62feb41a-be1f-4b1c-e089-27f97c0e8d00",
			primaryColor: "#FFFFFF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:80001"
		],
		mobile: {
			androidId: "co.theeasy.app",
			iosId: "id1641192503",
			native: "co.theeasy.app://wc",
			universal: "https://link.easy.me/wc"
		},
		name: "EASY",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	strikexwallet: {
		brand: {
			alt: "StrikeX Wallet Wallet",
			imageId: "eb2b6db5-1086-4739-a422-4a4bf3a44300"
		},
		chains: [
			"eip155:1",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.tradestrike",
			iosId: "id6443517613",
			native: "strikex://wc"
		},
		name: "StrikeX Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	avacus: {
		brand: {
			alt: "Avacus Wallet",
			imageId: "a7106965-91cc-4a73-4688-c5c72ae0ed00",
			primaryColor: "#FA8731"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.floortracks.avacus",
			iosId: "id1339638445",
			native: "avacus://wc",
			universal: "https://avacus.app.link/wc"
		},
		name: "Avacus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bytebank: {
		brand: {
			alt: "ByteBank Wallet",
			imageId: "bc7aacd6-b2e2-4146-7d21-06e0c5d44f00"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.hideout.wallet",
			iosId: "id1620315192",
			native: "hideoutWallet://wc"
		},
		name: "ByteBank",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	coolwallet: {
		brand: {
			alt: "CoolWallet Wallet",
			imageId: "f581365d-e844-4d21-8e35-44a755a32d00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:25",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.coolbitx.cwsapp",
			iosId: "id1328764142",
			native: "coolwallet://wc"
		},
		name: "CoolWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	optowallet: {
		brand: {
			alt: "Opto Wallet Wallet",
			imageId: "3df102e4-e435-49dd-d4b1-5ea74ebed500",
			primaryColor: "#0caade"
		},
		chains: [
			"near:mainnet",
			"near:testnet"
		],
		mobile: {
			androidId: "app.opto.wallet",
			iosId: "id6443854537",
			native: "opto://wc"
		},
		name: "Opto Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	tkfinance: {
		brand: {
			alt: "TK Finance Wallet",
			imageId: "c4066f68-2247-49bf-ac8a-a677bfa81800"
		},
		chains: [
			"eip155:1",
			"eip155:3",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			androidId: "com.trustkeysnetwork",
			iosId: "id1601968967",
			native: "tk://wc"
		},
		name: "TK Finance",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	bee: {
		brand: {
			alt: "Bee Wallet",
			imageId: "f90bc33f-f085-40cf-7538-fae5ae84f900",
			primaryColor: "#14181E"
		},
		chains: [
			"eip155:1",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			iosId: "id1617257467",
			native: "beewallet.app://wc"
		},
		name: "Bee Wallet",
		shortName: "Bee",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	pitaka: {
		brand: {
			alt: "Pitaka Wallet",
			imageId: "691c0716-5213-4b99-e837-079268313800",
			primaryColor: "#7a2090"
		},
		chains: [
			"cosmos:kava-4",
			"eip155:1",
			"eip155:10",
			"eip155:10000",
			"eip155:10001",
			"eip155:1001",
			"eip155:10101",
			"eip155:1028",
			"eip155:11297108099",
			"eip155:11297108109",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:1313161556",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:1666600003",
			"eip155:1666700000",
			"eip155:1666700001",
			"eip155:1666700002",
			"eip155:1666700003",
			"eip155:19",
			"eip155:199",
			"eip155:200",
			"eip155:25",
			"eip155:28",
			"eip155:288",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:32659",
			"eip155:333888",
			"eip155:333999",
			"eip155:4",
			"eip155:40",
			"eip155:4002",
			"eip155:41",
			"eip155:42",
			"eip155:42161",
			"eip155:43113",
			"eip155:43114",
			"eip155:44787",
			"eip155:4689",
			"eip155:4690",
			"eip155:5",
			"eip155:56",
			"eip155:6",
			"eip155:61",
			"eip155:62",
			"eip155:63",
			"eip155:65",
			"eip155:66",
			"eip155:8",
			"eip155:8217",
			"eip155:9",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182"
		],
		mobile: {
			androidId: "com.pitakamobile",
			ios: "https://testflight.apple.com/join/nO1eKTVP",
			native: "pitaka://wc",
			universal: "https://app.pitaka.io/wc"
		},
		name: "Pitaka",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	coinstats: {
		brand: {
			alt: "CoinStats Wallet",
			imageId: "b2a00908-f144-4a49-cc0a-9d7422ad5e00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			native: "coinstats://wc"
		},
		mobile: {
			androidId: "com.coinstats.crypto.portfolio",
			iosId: "id1247849330",
			native: "coinstats://wc"
		},
		name: "CoinStats",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	mdaowallet: {
		brand: {
			alt: "MDAO Wallet Wallet",
			imageId: "82014e92-838b-4e75-e77e-76cdc5539d00",
			primaryColor: "#1BD099"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.ttmbank.wallet.app",
			iosId: "id1540851562",
			native: "ttmwalletapp://wc"
		},
		name: "MDAO Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	pltwallet: {
		brand: {
			alt: "PLTwallet Wallet",
			imageId: "a5d9dd15-8cef-42de-8bed-09e01a8b0200",
			primaryColor: "#ffffff"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.palettechain.wallet",
			iosId: "id1581055631",
			native: "pltwallet://wc",
			universal: "https://pltwallet.io/wc"
		},
		name: "PLTwallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	helixid: {
		brand: {
			alt: "helixid Wallet",
			imageId: "4083ef71-8389-4682-ded6-0099236d2e00",
			primaryColor: "#0021FF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:4",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.io.helix.id",
			iosId: "id1469238013",
			native: "helix-id://wc"
		},
		name: "helix id",
		shortName: "helixid",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	airgap: {
		brand: {
			alt: "AirGap Wallet",
			imageId: "76bfe8cd-cf3f-4341-c33c-60da01065000",
			primaryColor: "#50249f"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "it.airgap.wallet",
			iosId: "id1420996542",
			native: "airgap-wallet://wc"
		},
		name: "AirGap Wallet",
		shortName: "AirGap",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	qubic: {
		brand: {
			alt: "Qubic Wallet",
			imageId: "535c91a5-a43c-4104-233c-439449ffcd00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "app.qubic.wallet",
			iosId: "id1563987988",
			native: "qubic://wc",
			universal: "https://wallet.qubic.app/wc"
		},
		name: "Qubic Wallet",
		shortName: "Qubic",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	havenwallet: {
		brand: {
			alt: "Haven Wallet Wallet",
			imageId: "b41fc3f2-a874-45ae-4d4f-cdf47da89500",
			primaryColor: "#194AF9"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "io.wallet.haven",
			iosId: "id1634596545"
		},
		name: "Haven Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	holdstationwallet: {
		brand: {
			alt: "Holdstation Wallet Wallet",
			imageId: "e6dba126-85af-4194-84f6-dd16632c3c00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "io.holdstation",
			iosId: "id6444925618",
			universal: "https://apps.apple.com/us/app/holdstation-web3-wallet/id6444925618/wc"
		},
		name: "Holdstation Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	earthwallet: {
		brand: {
			alt: "Earth Wallet Wallet",
			imageId: "d3f724c4-f99b-476f-10f8-12aa4af13800"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "earth.wallet.app",
			iosId: "id1638414929",
			native: "earthwallet://wc"
		},
		name: "Earth Wallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	metaone: {
		brand: {
			alt: "MetaOne Wallet",
			imageId: "b869d966-4699-44de-eadb-4eb39a580600",
			primaryColor: "#2000F0"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:1666600000",
			"eip155:56"
		],
		mobile: {
			androidId: "ventures.aag.metaone",
			iosId: "id1627212812",
			native: "metaone://wc"
		},
		name: "MetaOne",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	"3s": {
		brand: {
			alt: "3S Wallet",
			imageId: "f3b6a89d-ec8f-49dc-e07f-6bf723e1e500",
			primaryColor: "#D10D79"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		mobile: {
			androidId: "network.bho.wallet",
			iosId: "id1622316272",
			native: "bhcwallet://wc"
		},
		name: "3S Wallet",
		shortName: "3S",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	simplehold: {
		brand: {
			alt: "SimpleHold Wallet",
			imageId: "a9f1ba96-b658-4d13-f71f-226b6389f000",
			primaryColor: "#3FBB7D"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:kava-4",
			"eip155:1",
			"eip155:137",
			"eip155:1666600003",
			"eip155:250",
			"eip155:361",
			"eip155:43114",
			"eip155:4689",
			"eip155:50",
			"eip155:56",
			"eip155:61",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.simplehold.app",
			iosId: "id1589064973",
			native: "simplehold://wc",
			universal: "https://simplehold.io/wc"
		},
		name: "SimpleHold",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	payperless: {
		brand: {
			alt: "Payperless Wallet",
			imageId: "4a867e30-44c9-4627-6281-33457b8e2100"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"eip155:61"
		],
		mobile: {
			androidId: "com.payperless.wallet",
			iosId: "id1552741313"
		},
		name: "Payperless",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	minerva: {
		brand: {
			alt: "Minerva Wallet",
			imageId: "b57b2163-1bd8-4f6b-3311-470767e6d200",
			primaryColor: "#6141d2"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:420",
			"eip155:42161",
			"eip155:42220",
			"eip155:43113",
			"eip155:43114",
			"eip155:44787",
			"eip155:5",
			"eip155:56",
			"eip155:62320",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "digital.minerva",
			ios: "",
			native: "minerva://wc",
			universal: "https://minerva.digital/wc"
		},
		name: "Minerva Wallet",
		shortName: "Minerva",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	voltdefi: {
		brand: {
			alt: "Volt: DeFi Wallet",
			imageId: "51d783cb-0686-4ffa-e661-edca0c380000",
			primaryColor: "#70E000"
		},
		chains: [
			"eip155:122"
		],
		mobile: {
			androidId: "finance.voltage.app",
			iosId: "id6444159237",
			native: "volt://wc",
			universal: "https://get.voltage.finance/wc"
		},
		name: "Volt: DeFi",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	lif3: {
		brand: {
			alt: "Lif3 Wallet",
			imageId: "1a89c0ec-9059-4515-afb6-8204d49f0900"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			android: "",
			iosId: "id6444389674"
		},
		name: "Lif3 Wallet",
		shortName: "Lif3",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	bobablocks: {
		brand: {
			alt: "bobablocks Wallet",
			imageId: "aff8973b-e093-45b5-4858-c01dd043bc00",
			primaryColor: "#1c3146"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			native: "bobablocks://wc"
		},
		mobile: {
			androidId: "io.bumoon.boo",
			iosId: "id1593710564",
			native: "bobablocks://wc"
		},
		name: "bobablocks",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	shinobi: {
		brand: {
			alt: "Shinobi Wallet",
			imageId: "685c986c-3e80-4701-cec6-cd247ba1a700"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:3",
			"eip155:4",
			"eip155:420",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "io.fgraph.shinobiwallet",
			iosId: "id1572609905",
			native: "shinobi-wallet://wc"
		},
		name: "Shinobi-Wallet",
		shortName: "Shinobi",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	kryptogo: {
		brand: {
			alt: "KryptoGO Wallet",
			imageId: "3ccbd966-97e8-45a0-1ceb-6141a8978e00",
			primaryColor: "#FFC211"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:321",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "com.kryptogo.walletapp",
			iosId: "id1593830910",
			native: "kryptogo://wc",
			universal: "https://kryptogo.page.link/wc"
		},
		name: "KryptoGO Wallet",
		shortName: "KryptoGO",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	autonomy: {
		brand: {
			alt: "Autonomy Wallet",
			imageId: "126a7683-2349-45c6-ed19-0e27a645c000"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.bitmark.autonomy_client",
			iosId: "id1544022728",
			native: "autonomy-wc://wc",
			universal: "https://autonomy.io/apps/wc"
		},
		name: "Autonomy: Digital Art Wallet",
		shortName: "Autonomy",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bifrostwallet: {
		brand: {
			alt: "Bifrost Wallet Wallet",
			imageId: "86be07e2-6652-4fd1-5f33-651682c95400"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:14",
			"eip155:16",
			"eip155:19",
			"eip155:250",
			"eip155:4002",
			"eip155:420",
			"eip155:42161",
			"eip155:421611",
			"eip155:5",
			"eip155:56",
			"eip155:69",
			"eip155:97",
			"xrpl:0",
			"xrpl:1"
		],
		mobile: {
			androidId: "com.bifrostwallet.app",
			iosId: "id1577198351",
			native: "bifrostwallet://wc",
			universal: "https://app.bifrostwallet.com/wc"
		},
		name: "Bifrost Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	nufinetes: {
		brand: {
			alt: "nufinetes Wallet",
			imageId: "4bb6c1ca-4196-4ba3-ece2-c3d335e1f800"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			native: "vimwallet://wc"
		},
		mobile: {
			androidId: "com.vimworld.wallet",
			iosId: "id1609562349",
			native: "vimwallet://wc"
		},
		name: "Nufinetes",
		shortName: "nufinetes",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	freedomworld: {
		brand: {
			alt: "Freedom World Wallet",
			imageId: "42a6f275-96c8-4cd0-9b7a-acc5f054a800"
		},
		chains: [
			"eip155:122"
		],
		mobile: {
			androidId: "com.bitazza.freedom.wallet",
			iosId: "id1606936073",
			native: "freedom-wallet://wc"
		},
		name: "Freedom World",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	wallet3: {
		brand: {
			alt: "Wallet3 Wallet",
			imageId: "34ab7558-9e64-4436-f4e6-9069f2533d00",
			primaryColor: "#6186ff"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:1313161554",
			"eip155:137",
			"eip155:1666600000",
			"eip155:2020",
			"eip155:25",
			"eip155:250",
			"eip155:28",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:56",
			"eip155:66",
			"eip155:8217"
		],
		desktop: {
			native: "wallet3://wc"
		},
		mobile: {
			androidId: "jp.co.chainbow.wallet3.mobile",
			iosId: "id1597395741",
			native: "wallet3://wc"
		},
		name: "Wallet 3",
		shortName: "Wallet3",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	abra: {
		brand: {
			alt: "Abra  Wallet",
			imageId: "2219db01-e0c9-471c-5def-fd3b4e7a7a00",
			primaryColor: "#ffffff"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42161",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			android: "https://abra.com",
			ios: "https://abra.com",
			native: "abra://wc"
		},
		name: "Abra Wallet",
		shortName: "Abra ",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ime: {
		brand: {
			alt: "iMe Wallet",
			imageId: "25aa3abf-901b-4d82-bb89-c5ade54c0c00",
			primaryColor: "#0154D6"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:3",
			"eip155:4002",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "com.iMe.android",
			iosId: "id1450480822",
			native: "wc://wc"
		},
		name: "iMe",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	prema: {
		brand: {
			alt: "PREMA Wallet",
			imageId: "6487869b-1165-4f30-aa3a-115665be8300",
			primaryColor: "#0e58a6"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:128",
			"eip155:137",
			"eip155:1666600000",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:88"
		],
		desktop: {
			native: "premawallet://wc",
			universal: "https://premanft.com"
		},
		mobile: {
			androidId: "co.jp.xcreation.premawallet",
			iosId: "id1603556315",
			native: "premawallet://wc",
			universal: "https://premanft.com/wc"
		},
		name: "PREMA Wallet",
		shortName: "PREMA",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	onekey: {
		brand: {
			alt: "OneKey Wallet",
			imageId: "12bebb3f-8030-4892-8452-c60a6bac1500",
			primaryColor: "#00B812"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:128",
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:1313161556",
			"eip155:137",
			"eip155:250",
			"eip155:256",
			"eip155:28",
			"eip155:3",
			"eip155:338",
			"eip155:4",
			"eip155:42161",
			"eip155:42220",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:6",
			"eip155:61",
			"eip155:62",
			"eip155:62320",
			"eip155:63",
			"eip155:65",
			"eip155:66",
			"eip155:69",
			"eip155:80001",
			"eip155:97",
			"near:mainnet",
			"near:testnet",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K"
		],
		desktop: {
			chromeId: "jnmbobjmhlngoefaiojfljckilhhlhcj",
			native: "onekey-wallet://wc",
			universal: "https://app.onekey.so/wc/connect"
		},
		mobile: {
			androidId: "so.onekey.app.wallet",
			iosId: "id1609559473",
			native: "onekey-wallet://wc",
			universal: "https://app.onekey.so/wc/connect/wc"
		},
		name: "OneKey",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	slingshot: {
		brand: {
			alt: "Slingshot Wallet",
			imageId: "10c75467-6612-48ad-b97b-63985e922200",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "com.slingshot.finance",
			iosId: "id1633406472",
			native: "slingshot://wc",
			universal: "https://app.slingshot.finance/wc"
		},
		name: "Slingshot Wallet",
		shortName: "Slingshot",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	gaspackapp: {
		brand: {
			alt: "Gaspack App Wallet",
			imageId: "7ba121b2-3bd0-477e-f77b-ed0286535c00",
			primaryColor: "#0c0081"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:80001"
		],
		name: "Gaspack App",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	kriptonio: {
		brand: {
			alt: "Kriptonio Wallet",
			imageId: "363fae03-882a-4d81-a721-6e6f6e9ac500",
			primaryColor: "#4881C9"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.kriptonio.mobile.android",
			iosId: "id6444807361",
			native: "kriptonio://wc",
			universal: "https://app.kriptonio.com/mobile/wc"
		},
		name: "Kriptonio",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	timeless: {
		brand: {
			alt: "Timeless Wallet",
			imageId: "32e89601-0490-42fc-0cc4-8627d62a2000",
			primaryColor: "#2D3A66"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:1666600000",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			iosId: "id1592807339",
			native: "timeless-wallet://wc",
			universal: "https://timelesswallet.xyz/wc"
		},
		name: "Timeless Wallet",
		shortName: "Timeless",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	secux: {
		brand: {
			alt: "SecuX Wallet",
			imageId: "98183be0-3125-45ee-a6b6-fbd47ebefd00"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		desktop: {
			native: "secux://wc",
			universal: "https://wsweb.secuxtech.com"
		},
		mobile: {
			androidId: "com.secuxapp",
			iosId: "id1477437607",
			native: "secux://wc"
		},
		name: "SecuX",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	venly: {
		brand: {
			alt: "Venly Wallet",
			imageId: "d8c846d0-5164-4520-d10f-e1c27d69ce00"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:31337",
			"eip155:43113",
			"eip155:43114",
			"eip155:5",
			"eip155:56",
			"eip155:60",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			universal: "https://walletconnect.venly.io"
		},
		name: "Venly",
		walletConnect: {
			sdks: [
				"sign_v2",
				"auth_v1"
			]
		}
	},
	bitski: {
		brand: {
			alt: "Bitski Wallet",
			imageId: "94d94cb5-a94f-47cf-70e6-fe8d3f1c3700",
			primaryColor: "#FF245A"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:5",
			"eip155:80001"
		],
		desktop: {
			chromeId: "feejiigddaafeojfddjjlmfkabimkell",
			universal: "https://chrome.google.com/webstore/detail/bitski/feejiigddaafeojfddjjlmfkabimkell"
		},
		mobile: {
			iosId: "id1587199538",
			native: "bitski://wc",
			universal: "https://wallet.bitski.com/walletconnect/wc"
		},
		name: "Bitski",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mpcwallet: {
		brand: {
			alt: "MPCWallet Wallet",
			imageId: "636ff7d4-79ce-41d6-ede5-85c9f8a1d900"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:128",
			"eip155:137",
			"eip155:210309",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:61"
		],
		mobile: {
			androidId: "xyz.mpcwallet.pro",
			iosId: "id6443522988"
		},
		name: "MPCWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	xdefiwallet: {
		brand: {
			alt: "XDEFI Wallet Wallet",
			imageId: "efec6318-7f96-4b30-9287-6c287660cd00"
		},
		chains: [
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:10000",
			"eip155:1313161554",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"near:mainnet",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			chromeId: "hmeobnfnfcmdkdcmlblgagmfpfboieaf"
		},
		name: "XDEFI Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	treasure: {
		brand: {
			alt: "TREASURE Wallet",
			imageId: "6b5d45f6-117c-44a0-d7b0-71c28864a100"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:128",
			"eip155:137",
			"eip155:200",
			"eip155:25",
			"eip155:250",
			"eip155:4",
			"eip155:42220",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.crypto.treasure"
		},
		name: "TREASURE",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	streakkwallet: {
		brand: {
			alt: "Streakk Wallet Wallet",
			imageId: "45ec6eb9-d7fe-4b9b-6dbf-cc675c5d1d00"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.streakk",
			iosId: "id1636671089",
			native: "streakk://wc"
		},
		name: "Streakk Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	okxwallet: {
		brand: {
			alt: "OKX Wallet Wallet",
			imageId: "45f2f08e-fc0c-4d62-3e63-404e72170500"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"eip155:66"
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			iosId: "id1327268470",
			native: "okex://wc"
		},
		name: "OKX Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	sender: {
		brand: {
			alt: "Sender Wallet",
			imageId: "6fb46282-3d15-4c8a-41ae-0d52115e3f00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"near:mainnet"
		],
		desktop: {
			chromeId: "epapihdplajcdnnkdeiahlgigofloibg"
		},
		mobile: {
			androidId: "com.sender_wallet_mobile",
			iosId: "id1637821762"
		},
		name: "Sender",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	saitapro: {
		brand: {
			alt: "SaitaPro Wallet",
			imageId: "65bdc812-5692-441f-abcb-a389b754a700"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.saitapro",
			iosId: "id1636523777",
			native: "SaitaPro://wc"
		},
		name: "SaitaPro",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	lilico: {
		brand: {
			alt: "Lilico Wallet",
			primaryColor: "#FC814A",
			spriteId: "lilico"
		},
		chains: [
			"flow:mainnet",
			"flow:testnet"
		],
		desktop: {
			chromeId: "hpclkefagolihohboafpheddmmgdffjm"
		},
		mobile: {
			androidId: "io.outblock.lilico",
			iosId: "id1644169603",
			native: "lilico://wc",
			universal: "https://link.lilico.app/wc"
		},
		name: "Lilico",
		shortName: "lilico",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	hippowallet: {
		brand: {
			alt: "HippoWallet Wallet",
			imageId: "f9570968-45f7-47c1-3189-98cf60e25c00",
			primaryColor: "#347362"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "com.blockchaincommodities.hippo_wallet",
			iosId: "id1613041499",
			native: "hippowallet://wc"
		},
		name: "Hippo Wallet",
		shortName: "HippoWallet",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		}
	},
	cosmostation: {
		brand: {
			alt: "Cosmostation Wallet",
			imageId: "ea26c3c8-adb6-4dc4-ee02-35d6eee02800",
			primaryColor: "#9c6cff"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"cosmos:irishub-1",
			"cosmos:kava-4",
			"eip155:66"
		],
		mobile: {
			androidId: "wannabit.io.cosmostaion",
			iosId: "id1459830339",
			native: "cosmostation://wc"
		},
		name: "Cosmostation",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bitizen: {
		brand: {
			alt: "Bitizen Wallet",
			imageId: "75dd1471-77e9-4811-ce57-ec8fc980ec00",
			primaryColor: "#00B78C"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1001",
			"eip155:1007",
			"eip155:101",
			"eip155:1010",
			"eip155:1012",
			"eip155:102",
			"eip155:1022",
			"eip155:1023",
			"eip155:1024",
			"eip155:1028",
			"eip155:106",
			"eip155:108",
			"eip155:11",
			"eip155:110",
			"eip155:111",
			"eip155:1139",
			"eip155:12",
			"eip155:122",
			"eip155:124",
			"eip155:127",
			"eip155:128",
			"eip155:1284",
			"eip155:1285",
			"eip155:13",
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:1313161556",
			"eip155:137",
			"eip155:14",
			"eip155:142",
			"eip155:15",
			"eip155:16",
			"eip155:162",
			"eip155:163",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:1666600003",
			"eip155:1666700000",
			"eip155:1666700001",
			"eip155:1666700002",
			"eip155:1666700003",
			"eip155:17",
			"eip155:170",
			"eip155:172",
			"eip155:18",
			"eip155:186",
			"eip155:19",
			"eip155:199",
			"eip155:2",
			"eip155:20",
			"eip155:200",
			"eip155:21",
			"eip155:210309",
			"eip155:211",
			"eip155:22",
			"eip155:222",
			"eip155:23",
			"eip155:246",
			"eip155:25",
			"eip155:250",
			"eip155:256",
			"eip155:262",
			"eip155:269",
			"eip155:27",
			"eip155:28",
			"eip155:288",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:32",
			"eip155:321",
			"eip155:322",
			"eip155:33",
			"eip155:336",
			"eip155:338",
			"eip155:35",
			"eip155:361",
			"eip155:363",
			"eip155:364",
			"eip155:365",
			"eip155:369",
			"eip155:38",
			"eip155:385",
			"eip155:4",
			"eip155:40",
			"eip155:4002",
			"eip155:41",
			"eip155:42",
			"eip155:420",
			"eip155:42161",
			"eip155:421611",
			"eip155:42220",
			"eip155:43",
			"eip155:43113",
			"eip155:43114",
			"eip155:44",
			"eip155:44787",
			"eip155:499",
			"eip155:5",
			"eip155:50",
			"eip155:51",
			"eip155:52",
			"eip155:53",
			"eip155:55",
			"eip155:558",
			"eip155:56",
			"eip155:58",
			"eip155:59",
			"eip155:595",
			"eip155:6",
			"eip155:60",
			"eip155:61",
			"eip155:62",
			"eip155:63",
			"eip155:64",
			"eip155:65",
			"eip155:66",
			"eip155:67",
			"eip155:68",
			"eip155:686",
			"eip155:69",
			"eip155:7",
			"eip155:721",
			"eip155:76",
			"eip155:77",
			"eip155:777",
			"eip155:78",
			"eip155:787",
			"eip155:8",
			"eip155:80",
			"eip155:80001",
			"eip155:803",
			"eip155:82",
			"eip155:820",
			"eip155:821",
			"eip155:8217",
			"eip155:83",
			"eip155:85",
			"eip155:86",
			"eip155:880",
			"eip155:888",
			"eip155:9",
			"eip155:940",
			"eip155:95",
			"eip155:97",
			"eip155:977",
			"eip155:99",
			"eip155:998",
			"eip155:999"
		],
		mobile: {
			androidId: "org.bitizen.wallet",
			iosId: "id1598283542",
			native: "bitizen://wc",
			universal: "https://bitizen.org/wallet/wc"
		},
		name: "Bitizen",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	humblwallet: {
		brand: {
			alt: "Humbl Wallet Wallet",
			imageId: "1ac55ba2-aa98-4ed0-59b3-b3155dea4200",
			primaryColor: "#24ace4"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "com.humbl.wallet.app",
			iosId: "id1627171234",
			native: "humblwallet://wc"
		},
		name: "HUMBL WALLET",
		shortName: "Humbl Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	safemoon: {
		brand: {
			alt: "SafeMoon Wallet",
			imageId: "ea0140c7-787c-43a4-838f-d5ab6a342000",
			primaryColor: "#00a79d"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			native: "safemoon://wc",
			universal: "https://safemoon.com/wc"
		},
		mobile: {
			androidId: "net.safemoon.androidwallet",
			iosId: "id1579735495",
			native: "safemoon://wc",
			universal: "https://safemoon.com/wc"
		},
		name: "SafeMoon",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	passpay: {
		brand: {
			alt: "passpay Wallet",
			imageId: "a1c337f5-c156-4ce8-763b-b4cc65f1c200"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			iosId: "id1645009398",
			native: "com.wallet.passpay://wc"
		},
		name: "PassPay Wallet",
		shortName: "passpay",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ultimate: {
		brand: {
			alt: "Ultimate Wallet",
			imageId: "1ed9823d-64dd-4ab6-2f3f-22c8ff228f00",
			primaryColor: "#6153FC"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			android: "",
			iosId: "id1629053410",
			native: "ultimate://wc"
		},
		name: "Ultimate",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mewallet: {
		brand: {
			alt: "ME Wallet Wallet",
			imageId: "e9666b15-4296-4384-3661-7e99a5f2a900"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:420",
			"eip155:42161",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		desktop: {
			universal: "https://app.astrox.me/"
		},
		mobile: {
			androidId: "com.astrox.me",
			iosId: "id1634031707"
		},
		name: "MeWallet",
		shortName: "ME Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	thorwallet: {
		brand: {
			alt: "THORWallet Wallet",
			imageId: "45165bea-fdae-454e-7caa-31681f255200"
		},
		chains: [
			"cosmos:mayachain-mainnet-v1",
			"cosmos:thorchain-mainnet-v1",
			"eip155:1",
			"eip155:10000",
			"eip155:1284",
			"eip155:1285",
			"eip155:137",
			"eip155:324",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "defisuisse.thorwallet",
			iosId: "id1592064324",
			native: "thorwallet://wc"
		},
		name: "THORWallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	fizz: {
		brand: {
			alt: "Fizz Wallet",
			imageId: "f9d4db84-2e9f-4fbe-684f-c1e921c98800",
			primaryColor: "#8151ff"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			iosId: "id6447460538",
			native: "fizz://wc"
		},
		name: "Fizz",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	piethereumhardware: {
		brand: {
			alt: "PiEthereumHardware Wallet",
			imageId: "310a5036-3c8f-4bfc-0510-cba61d7d5100"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42161"
		],
		name: "PiEthereum Hardware",
		shortName: "PiEthereumHardware",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	reunit: {
		brand: {
			alt: "Reunit Wallet",
			imageId: "98ed357f-1e2d-4679-0e78-1100f7594000"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			chromeId: "nlcccgcedoleehdicpnlnjeccnlfkemh"
		},
		name: "Reunit",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	ipermatchapp: {
		brand: {
			alt: "Ipermatch App Wallet",
			imageId: "c8b5ba4f-b3be-4bc1-55ed-c6a56a8aef00",
			primaryColor: "#007bff"
		},
		chains: [
			"eip155:42220",
			"eip155:44787"
		],
		name: "Ipermatch App",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	party: {
		brand: {
			alt: "Party Wallet",
			imageId: "0ef6e0fa-6cf0-460a-2f31-abe28bd28f00"
		},
		chains: [
			"eip155:1",
			"eip155:5"
		],
		name: "Party",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	b1ock: {
		brand: {
			alt: "B1ock Wallet",
			imageId: "82733724-329c-4e24-e4d4-f5635875af00"
		},
		chains: [
			"eip155:1",
			"eip155:43114",
			"near:mainnet"
		],
		name: "B1ock",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	tholos: {
		brand: {
			alt: "Tholos Wallet",
			imageId: "f0f306e6-2dba-4805-e7b9-4f25952e2900",
			primaryColor: "#135fff"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:80001"
		],
		mobile: {
			androidId: "app.tholos.tholos",
			iosId: "id1669578487"
		},
		name: "Tholos",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	stickey: {
		brand: {
			alt: "Stickey Wallet",
			imageId: "12aab9fb-f3d4-4248-10e0-4eda17a5de00",
			primaryColor: "#1973F6"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:321",
			"eip155:42161",
			"eip155:56"
		],
		desktop: {
			native: "stickyapp://wc",
			universal: "https://stickeyapp.page.link"
		},
		mobile: {
			androidId: "app.stickey",
			iosId: "id1671113083",
			native: "stickyapp://wc",
			universal: "https://stickeyapp.page.link/wc"
		},
		name: "Stickey Wallet",
		shortName: "Stickey",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	covey: {
		brand: {
			alt: "Covey Wallet",
			imageId: "75a2b3e4-ec3c-495a-9f4f-d7bd4883dc00",
			primaryColor: "#000229"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:4",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.covey.legends",
			iosId: "id6446903201",
			native: "coveylegends://wc"
		},
		name: "Covey Legends",
		shortName: "Covey",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	klip: {
		brand: {
			alt: "Klip Wallet",
			imageId: "f7b6b2a6-ebe7-4779-6ad1-79a3142e6b00",
			primaryColor: "#2D6AFF"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:8217"
		],
		mobile: {
			androidId: "com.klipwallet.app",
			iosId: "id1627665524",
			native: "klipwallet://wc"
		},
		name: "Klip",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	likerlandapp: {
		brand: {
			alt: "LikerLandApp Wallet",
			imageId: "501fa316-f0df-4a1b-ead6-5523251b7100",
			primaryColor: "#28646e"
		},
		chains: [
			"cosmos:likecoin-mainnet-2"
		],
		mobile: {
			androidId: "com.oice",
			iosId: "id1248232355",
			native: "com.oice://wc"
		},
		name: "LikerLand App",
		shortName: "LikerLandApp",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	krystalwallet: {
		brand: {
			alt: "Krystal Wallet Wallet",
			imageId: "d2b59965-4eb8-4828-d3d4-fbc0b3379e00",
			primaryColor: "#1DE9B6"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:1313161554",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:8217"
		],
		mobile: {
			androidId: "com.kyrd.krystal",
			iosId: "id1558105691",
			native: "krystalwallet://wc",
			universal: "https://defi.krystal.app/wc"
		},
		name: "Krystal",
		shortName: "Krystal Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	keepkey: {
		brand: {
			alt: "keepkey Wallet",
			imageId: "eb4227d9-366c-466c-db8f-ab7e45985500",
			primaryColor: "#B39C6F"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137"
		],
		desktop: {
			native: "keepkey://wc"
		},
		name: "KeepKey Desktop",
		shortName: "keepkey",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	plr: {
		brand: {
			alt: "PLR Wallet",
			imageId: "87737170-f79f-4359-338b-7c30856c9f00",
			primaryColor: "#7501D9"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:42161",
			"eip155:56"
		],
		mobile: {
			androidId: "com.pillarproject.wallet",
			iosId: "id1346582238",
			native: "pillarwallet://wc"
		},
		name: "Pillar",
		shortName: "PLR",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	hartiapp: {
		brand: {
			alt: "HARTi App Wallet",
			imageId: "d0407f26-fe0b-4f3c-43c3-69bc8fef2e00"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			androidId: "app.harti",
			iosId: "id1599921940",
			native: "HARTi://wc"
		},
		name: "HARTi Wallet",
		shortName: "HARTi App",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	stasiswallet: {
		brand: {
			alt: "Stasis Wallet Wallet",
			imageId: "d83223cf-f29a-4757-a21e-8913b12f9f00"
		},
		chains: [
			"algorand:SGO1GKSzyE7IEPItTxCByw9x8FmnrCDe",
			"algorand:wGHE2Pwdvd7S12BL5FaOP20EGYesN73k",
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:50",
			"eip155:51",
			"eip155:80001"
		],
		mobile: {
			androidId: "com.stasis.stasiswallet",
			iosId: "id1371949230",
			native: "stasis://wc"
		},
		name: "Stasis Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	novawallet: {
		brand: {
			alt: "Nova Wallet Wallet",
			imageId: "4f159b10-419b-483a-f2bf-da3d17855e00"
		},
		chains: [
			"eip155:1",
			"eip155:686",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f"
		],
		mobile: {
			androidId: "io.novafoundation.nova.market",
			iosId: "id1597119355",
			native: "novawallet://wc"
		},
		name: "Nova Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	betclover: {
		brand: {
			alt: "BETCLOVER Wallet",
			imageId: "590a5fd7-1771-4f6e-8b6f-1df0552fb700"
		},
		chains: [
			"eip155:333888",
			"eip155:333999",
			"eip155:56",
			"eip155:97"
		],
		name: "Bet Clover",
		shortName: "BETCLOVER",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	templardao: {
		brand: {
			alt: "Templar DAO Wallet",
			imageId: "5fde0020-c7b6-45e2-ab37-75ae5fdec700"
		},
		chains: [
			"eip155:56"
		],
		name: "TemplarDAO",
		shortName: "Templar DAO",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	metawonderverse: {
		brand: {
			alt: "meta-WONDER-verse Wallet",
			imageId: "5cc6d96d-178d-42a6-cba1-ebd9d9415700",
			primaryColor: "#58A7F0"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			universal: "https://metawonderverse.custonomy.io/"
		},
		name: "meta-WONDER-verse",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cyan: {
		brand: {
			alt: "CYAN Wallet",
			imageId: "959889ab-bd61-4c5d-f09c-f15fbece5500",
			primaryColor: "#00FFFF"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		name: "Cyan",
		shortName: "CYAN",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	forward: {
		brand: {
			alt: "Forward Wallet",
			imageId: "ad477dbe-f194-4a71-8013-781f180ad400",
			primaryColor: "#1c1c8e"
		},
		chains: [
			"algorand:SGO1GKSzyE7IEPItTxCByw9x8FmnrCDe",
			"algorand:mFgazF-2uRS1tMiL9dsj01hJGySEmPN2",
			"algorand:wGHE2Pwdvd7S12BL5FaOP20EGYesN73k",
			"cip-34:0-1",
			"cip-34:0-2",
			"cip-34:1-764824073",
			"cosmos:columbus-4",
			"cosmos:cosmoshub-4",
			"cosmos:harpoon-4",
			"cosmos:irishub-1",
			"cosmos:kaiyo-1",
			"cosmos:kava-4",
			"cosmos:likecoin-mainnet-2",
			"cosmos:likecoin-public-testnet-5",
			"cosmos:mayachain-mainnet-v1",
			"cosmos:mayachain-stagenet-v1",
			"cosmos:thorchain-mainnet-v1",
			"cosmos:thorchain-stagenet-v1",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:10000",
			"eip155:100000",
			"eip155:100001",
			"eip155:100002",
			"eip155:100003",
			"eip155:100004",
			"eip155:100005",
			"eip155:100006",
			"eip155:100007",
			"eip155:100008",
			"eip155:10001",
			"eip155:1001",
			"eip155:1007",
			"eip155:101",
			"eip155:1010",
			"eip155:10101",
			"eip155:1012",
			"eip155:102",
			"eip155:1022",
			"eip155:1023",
			"eip155:1024",
			"eip155:10243",
			"eip155:1028",
			"eip155:106",
			"eip155:108",
			"eip155:11",
			"eip155:110",
			"eip155:110000",
			"eip155:110001",
			"eip155:110002",
			"eip155:110003",
			"eip155:110004",
			"eip155:110005",
			"eip155:110006",
			"eip155:110007",
			"eip155:110008",
			"eip155:111",
			"eip155:1122334455",
			"eip155:11235",
			"eip155:11297108099",
			"eip155:11297108109",
			"eip155:1139",
			"eip155:1140",
			"eip155:11888",
			"eip155:12",
			"eip155:12051",
			"eip155:1213",
			"eip155:122",
			"eip155:124",
			"eip155:127",
			"eip155:128",
			"eip155:1280",
			"eip155:1284",
			"eip155:1285",
			"eip155:1286",
			"eip155:1287",
			"eip155:1288",
			"eip155:13",
			"eip155:1313114",
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:1313161556",
			"eip155:1313500",
			"eip155:13371337",
			"eip155:137",
			"eip155:14",
			"eip155:142",
			"eip155:15",
			"eip155:16",
			"eip155:16000",
			"eip155:16001",
			"eip155:1618",
			"eip155:162",
			"eip155:1620",
			"eip155:163",
			"eip155:1657",
			"eip155:1666600000",
			"eip155:1666600001",
			"eip155:1666600002",
			"eip155:1666600003",
			"eip155:1666700000",
			"eip155:1666700001",
			"eip155:1666700002",
			"eip155:1666700003",
			"eip155:17",
			"eip155:170",
			"eip155:172",
			"eip155:18",
			"eip155:18289463",
			"eip155:1856",
			"eip155:186",
			"eip155:19",
			"eip155:19011",
			"eip155:1987",
			"eip155:199",
			"eip155:1995",
			"eip155:2",
			"eip155:20",
			"eip155:200",
			"eip155:200625",
			"eip155:201030",
			"eip155:20181205",
			"eip155:2020",
			"eip155:2021",
			"eip155:2022",
			"eip155:21",
			"eip155:2100",
			"eip155:2101",
			"eip155:210309",
			"eip155:211",
			"eip155:22",
			"eip155:222",
			"eip155:23",
			"eip155:24484",
			"eip155:245022926",
			"eip155:245022934",
			"eip155:245022940",
			"eip155:246",
			"eip155:246529",
			"eip155:246785",
			"eip155:24734",
			"eip155:25",
			"eip155:250",
			"eip155:2559",
			"eip155:256",
			"eip155:262",
			"eip155:269",
			"eip155:27",
			"eip155:28",
			"eip155:280",
			"eip155:288",
			"eip155:28945486",
			"eip155:3",
			"eip155:30",
			"eip155:31",
			"eip155:31102",
			"eip155:311752642",
			"eip155:3125659152",
			"eip155:31337",
			"eip155:32",
			"eip155:321",
			"eip155:322",
			"eip155:324",
			"eip155:32659",
			"eip155:33",
			"eip155:333888",
			"eip155:333999",
			"eip155:336",
			"eip155:338",
			"eip155:35",
			"eip155:35855456",
			"eip155:361",
			"eip155:363",
			"eip155:364",
			"eip155:365",
			"eip155:369",
			"eip155:38",
			"eip155:385",
			"eip155:39797",
			"eip155:4",
			"eip155:40",
			"eip155:4002",
			"eip155:40875",
			"eip155:41",
			"eip155:42",
			"eip155:420",
			"eip155:42069",
			"eip155:42161",
			"eip155:421611",
			"eip155:4216137055",
			"eip155:42220",
			"eip155:43",
			"eip155:43110",
			"eip155:43113",
			"eip155:43114",
			"eip155:44",
			"eip155:44787",
			"eip155:4689",
			"eip155:4690",
			"eip155:4759",
			"eip155:48991",
			"eip155:49797",
			"eip155:499",
			"eip155:5",
			"eip155:50",
			"eip155:51",
			"eip155:5197",
			"eip155:52",
			"eip155:53",
			"eip155:54211",
			"eip155:55",
			"eip155:558",
			"eip155:56",
			"eip155:5700",
			"eip155:58",
			"eip155:5851",
			"eip155:5869",
			"eip155:59",
			"eip155:595",
			"eip155:6",
			"eip155:60",
			"eip155:60000",
			"eip155:60001",
			"eip155:60002",
			"eip155:60103",
			"eip155:61",
			"eip155:61717561",
			"eip155:62",
			"eip155:62320",
			"eip155:63",
			"eip155:64",
			"eip155:65",
			"eip155:66",
			"eip155:67",
			"eip155:68",
			"eip155:686",
			"eip155:69",
			"eip155:7",
			"eip155:70000",
			"eip155:70001",
			"eip155:70002",
			"eip155:70103",
			"eip155:7027",
			"eip155:71393",
			"eip155:721",
			"eip155:73799",
			"eip155:7518",
			"eip155:76",
			"eip155:77",
			"eip155:7762959",
			"eip155:777",
			"eip155:7777777",
			"eip155:78",
			"eip155:78110",
			"eip155:787",
			"eip155:8",
			"eip155:80",
			"eip155:80001",
			"eip155:8029",
			"eip155:803",
			"eip155:8080",
			"eip155:82",
			"eip155:820",
			"eip155:821",
			"eip155:8217",
			"eip155:8285",
			"eip155:83",
			"eip155:85",
			"eip155:86",
			"eip155:8723",
			"eip155:8724",
			"eip155:88",
			"eip155:880",
			"eip155:888",
			"eip155:8888",
			"eip155:8995",
			"eip155:9",
			"eip155:9000",
			"eip155:940",
			"eip155:95",
			"eip155:955305",
			"eip155:97",
			"eip155:977",
			"eip155:99",
			"eip155:99415706",
			"eip155:998",
			"eip155:999",
			"near:mainnet",
			"near:testnet"
		],
		name: "Forward",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	dttd: {
		brand: {
			alt: "DTTD Wallet",
			imageId: "4a1da9d0-1a81-4e51-4758-b2157f4e6000",
			primaryColor: "#03cafc"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		mobile: {
			android: "https://hop.dttd.app/googleplaydownload",
			ios: "https://hop.dttd.app/appstoredownload",
			native: "dotted://wc"
		},
		name: "DTTD",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	foxwallet: {
		brand: {
			alt: "FoxWallet Wallet",
			imageId: "d994a61e-c1df-49cb-cf4c-10ec51338400",
			primaryColor: "#EC7D43"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:56"
		],
		mobile: {
			androidId: "com.foxwallet.play",
			iosId: "id1590983231",
			native: "foxwallet://wc",
			universal: "https://link.foxwallet.com/wc"
		},
		name: "FoxWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	haqq: {
		brand: {
			alt: "HAQQ Wallet",
			imageId: "99fe539d-6a2a-4f52-2211-42fd04a9f300",
			primaryColor: "#04D484"
		},
		chains: [
			"eip155:11235",
			"eip155:54211"
		],
		mobile: {
			androidId: "com.haqq.wallet",
			iosId: "id6443843352",
			native: "haqq://wc"
		},
		name: "HAQQ Wallet",
		shortName: "HAQQ",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	tomipay: {
		brand: {
			alt: "tomiPAY Wallet",
			imageId: "bf8bd7b8-b638-40f6-1caa-1d7678bb1900",
			primaryColor: "#00F026"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.tomiapp.production",
			iosId: "id1643501440",
			native: "tomiwallet://wc"
		},
		name: "tomiPAY",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mar3: {
		brand: {
			alt: "mar3 Wallet",
			imageId: "973ffffe-403e-48b9-c59a-a3ea651f1500"
		},
		chains: [
			"eip155:56",
			"eip155:97"
		],
		name: "Mar3",
		shortName: "mar3",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	nash: {
		brand: {
			alt: "Nash Wallet",
			imageId: "93a15cd2-8f0d-4bf6-1545-6bdf745c2300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:42161",
			"eip155:43114",
			"neo3:mainnet"
		],
		mobile: {
			androidId: "io.nash.app",
			iosId: "id1475759236"
		},
		name: "Nash",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bybitwallet: {
		brand: {
			alt: "Bybit Wallet Wallet",
			imageId: "b9e64f74-0176-44fd-c603-673a45ed5b00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:250",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			chromeId: "pdliaogehgdbhbnmkklieghmmjkpigpa"
		},
		mobile: {
			androidId: "com.bybit.app",
			iosId: "id1488296980",
			native: "bybitapp://wc"
		},
		name: "Bybit Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	subwallet: {
		brand: {
			alt: "SubWallet Wallet",
			imageId: "03f5c08c-fb30-46a0-ca5c-d8fdd7250b00"
		},
		chains: [
			"eip155:1",
			"eip155:1284",
			"eip155:1285",
			"eip155:1287",
			"eip155:56",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f"
		],
		desktop: {
			chromeId: "onhogfjeacnfoofkfgppdlbmlmnplgbn",
			firefoxId: "subwallet"
		},
		mobile: {
			androidId: "app.subwallet.mobile",
			iosId: "id1633050285",
			native: "subwallet://wc",
			universal: "https://mobile.subwallet.app/wc"
		},
		name: "SubWallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	okto: {
		brand: {
			alt: "Okto Wallet",
			imageId: "154c69b7-9bb1-4010-5b4c-6b37eeda8900",
			primaryColor: "#5166EE"
		},
		chains: [
			"eip155:137",
			"eip155:250",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			universal: "https://okto.tech/"
		},
		mobile: {
			androidId: "com.coindcx.okto",
			iosId: "id6450688229",
			native: "okto://wc"
		},
		name: "Okto",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	cate: {
		brand: {
			alt: "Cate Wallet",
			imageId: "d017bc54-db4d-4f07-2de2-69790ce92400",
			primaryColor: "#FAA528"
		},
		chains: [
			"cip-34:1-764824073",
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "com.crypto.wallet.catecoin",
			iosId: "id1637850589",
			native: "catecoin://wc"
		},
		name: "Catecoin Wallet",
		shortName: "Cate",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ukiss: {
		brand: {
			alt: "UKISS Wallet",
			imageId: "23f4c933-68e6-46f9-75b6-2d2905ca1300"
		},
		chains: [
			"cip-34:1-764824073",
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:10000",
			"eip155:137",
			"eip155:25",
			"eip155:43114",
			"eip155:56",
			"eip155:61",
			"eip155:66",
			"eip155:8723",
			"near:mainnet",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ",
			"stellar:pubnet"
		],
		mobile: {
			androidId: "io.ukiss.uhub.mobile",
			native: "ukisshub://wc"
		},
		name: "UKISS Hub",
		shortName: "UKISS",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	tellaw: {
		brand: {
			alt: "Tellaw Wallet",
			imageId: "c1cb03f5-e1c2-4c3e-86e1-9a90565ea300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		mobile: {
			androidId: "com.tellaw.tellaw",
			iosId: "id6446802245",
			native: "tellaw://wc"
		},
		name: "Tellaw Wallet",
		shortName: "Tellaw",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	tangemwallet: {
		brand: {
			alt: "Tangem Wallet Wallet",
			imageId: "80679c6f-bb0b-43d0-83e0-462ac268b600",
			primaryColor: "#FFFFFF"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:61"
		],
		mobile: {
			androidId: "com.tangem.wallet",
			iosId: "id1354868448",
			native: "tangem://wc"
		},
		name: "Tangem Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	callback: {
		brand: {
			alt: "Callback Wallet",
			imageId: "9f50c7a7-2384-4efe-89c3-01e0fec2b700",
			primaryColor: "#181818"
		},
		chains: [
			"eip155:1"
		],
		mobile: {
			androidId: "com.thebasicsmeishi",
			iosId: "id1543659456",
			native: "callback://wc"
		},
		name: "Callback",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	saassistant: {
		brand: {
			alt: "SA ASSISTANT Wallet",
			imageId: "7954b508-9ff0-4416-9aba-16209b571000"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"eip155:1",
			"eip155:3",
			"eip155:4",
			"eip155:5",
			"eip155:56",
			"eip155:97",
			"polkadot:91b171bb158e2d3848fa23a9f1c25182",
			"polkadot:b0a8d493285c2df73290dfb7e61f870f"
		],
		mobile: {
			androidId: "com.onechain.saas",
			native: "saas://wc"
		},
		name: "SA ASSISTANT",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	rektmode: {
		brand: {
			alt: "REKTMODE Wallet",
			imageId: "6847439c-cce2-4595-617d-980eefafd300"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:5",
			"eip155:56",
			"eip155:80001"
		],
		name: "REKTMODE",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	xellar: {
		brand: {
			alt: "Xellar Wallet",
			imageId: "89cf9926-00bf-4152-d98f-cac53d7cad00",
			primaryColor: "#000000"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "com.xellar.wallets",
			iosId: "id1671215861",
			native: "xellar://wc"
		},
		name: "Xellar",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	mintopoly: {
		brand: {
			alt: "Mintopoly Wallet",
			imageId: "cf86c801-8c41-492d-6c69-a5133b6e2a00"
		},
		chains: [
			"eip155:1",
			"eip155:137"
		],
		name: "Mintopoly",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	talken: {
		brand: {
			alt: "Talken Wallet",
			imageId: "3c49e8e7-a4d8-4810-23ef-0a0102cce100"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:137",
			"eip155:25",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:8217"
		],
		mobile: {
			android: "https://play.google.com/store/search?q=talken&c=apps&hl=en-KR",
			iosId: "id1459475831",
			native: "talken-wallet://wc"
		},
		name: "Talken Wallet",
		shortName: "Talken",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	u2uwallet: {
		brand: {
			alt: "U2U Wallet Wallet",
			imageId: "03bca3fc-c191-4877-592d-0b0d6557c900",
			primaryColor: "#42B485"
		},
		chains: [
			"eip155:1",
			"eip155:56"
		],
		mobile: {
			androidId: "org.u2u.wallet",
			iosId: "id6446194312",
			native: "u2uwc://wc",
			universal: "https://u2u.page.link/wc"
		},
		name: "U2U Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	fungies: {
		brand: {
			alt: "Fungies Wallet",
			imageId: "cffd86f8-be6c-4842-b0d6-74440571c700"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:56",
			"eip155:80001",
			"eip155:97"
		],
		name: "Fungies",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	shidowallet: {
		brand: {
			alt: "Shido Wallet Wallet",
			imageId: "dd5c7007-4572-41c7-a9b8-b97d071adb00"
		},
		chains: [
			"eip155:1",
			"eip155:5",
			"eip155:56",
			"eip155:97"
		],
		mobile: {
			androidId: "com.shidowallet",
			iosId: "id6443624368",
			native: "shido://wc"
		},
		name: "Shido Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	ozone: {
		brand: {
			alt: "Ozone Wallet",
			imageId: "4eb57479-515a-463a-9fcb-c20e9cc60c00"
		},
		chains: [
			"eip155:61"
		],
		mobile: {
			androidId: "com.chiatk.apps.ozone1",
			native: "chiawallet://wc"
		},
		name: "OzoneWallet",
		shortName: "Ozone",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	tidus: {
		brand: {
			alt: "Tidus Wallet",
			imageId: "797bd108-d862-4d1b-d339-883de9a75000",
			primaryColor: "#01A9F5"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			androidId: "co.nycrypto.tiduswallet",
			native: "tiduswallet://wc"
		},
		name: "Tidus Wallet ",
		shortName: "Tidus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	impactsx: {
		brand: {
			alt: "ImpactsX Wallet",
			imageId: "afc85418-2ca6-46cf-cfb9-daf6bc43e400",
			primaryColor: "#002A3F"
		},
		chains: [
			"cosmos:cosmoshub-4"
		],
		mobile: {
			androidId: "com.ixo.mobile",
			iosId: "id6444948058",
			native: "impactsx://wc"
		},
		name: "Impact Wallet",
		shortName: "ImpactsX",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	zel: {
		brand: {
			alt: "zel Wallet",
			imageId: "1b9e652e-1667-425a-f828-707bf9b05400",
			primaryColor: "#DA4DFF"
		},
		chains: [
			"eip155:1",
			"eip155:56",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			native: "zel://wc"
		},
		mobile: {
			androidId: "com.zelcash.zelcore",
			iosId: "id1436296839",
			native: "zel://wc"
		},
		name: "Zelcore",
		shortName: "zel",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	dosivault: {
		brand: {
			alt: "DOSI Vault Wallet",
			imageId: "0a0d223e-6bf7-4e12-a5b4-1720deb02000"
		},
		chains: [
			"cosmos:cosmoshub-4"
		],
		desktop: {
			chromeId: "blpiicikpimmklhoiploliaenjmecabp",
			firefoxId: "dosi-vault",
			universal: "https://dosivault.page.link/qL6j"
		},
		mobile: {
			androidId: "world.dosi.vault",
			iosId: "id1664013594",
			native: "app.dosivault://wc"
		},
		name: "DOSI Vault",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	wowearn: {
		brand: {
			alt: "WOW EARN Wallet",
			imageId: "1985a753-7fd8-4d75-4c50-7998ea68a800"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			androidId: "com.hxg.wallet",
			iosId: "id6443434220",
			native: "ullawallet://wc"
		},
		name: "WOW EARN",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	ellipal: {
		brand: {
			alt: "ELLIPAL Wallet",
			imageId: "0a5b45a1-c974-4f41-6c14-376714478c00",
			primaryColor: "#1f84f3"
		},
		chains: [
			"eip155:1",
			"eip155:128",
			"eip155:137",
			"eip155:56"
		],
		mobile: {
			iosId: "id1426179665",
			native: "ELLIPAL://wc"
		},
		name: "ELLIPAL",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	unstoppablewallet: {
		brand: {
			alt: "Unstoppable Wallet Wallet",
			imageId: "a63cbfce-0726-4f94-9187-a761afb94400",
			primaryColor: "#FFB605"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:250",
			"eip155:42161",
			"eip155:43114",
			"eip155:56"
		],
		mobile: {
			androidId: "io.horizontalsystems.bankwallet",
			iosId: "id1447619907",
			native: "unstoppable.money://wc"
		},
		name: "Unstoppable Wallet",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	aurorapass: {
		brand: {
			alt: "Aurora Pass Wallet",
			imageId: "6d93eeba-edce-431c-4293-e25784e61f00"
		},
		chains: [
			"eip155:1313161554",
			"eip155:1313161555",
			"eip155:1313161556"
		],
		mobile: {
			androidId: "aurora.pass.android.app",
			iosId: "id6447244286",
			native: "aurora-pass://wc"
		},
		name: "Aurora Pass",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	bitverse: {
		brand: {
			alt: "Bitverse Wallet",
			imageId: "5851c585-0f2b-41a1-a36a-221a18af5200"
		},
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:288",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:56",
			"eip155:66"
		],
		desktop: {
			chromeId: "gkeelndblnomfmjnophbhfhcjbcnemka"
		},
		mobile: {
			androidId: "com.bitverse.app",
			ios: "https://apps.apple.com/app/1645515614",
			native: "bitverseapp://wc",
			universal: "https://bitverseapp.page.link/wc"
		},
		name: "Bitverse",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	konio: {
		brand: {
			alt: "konio Wallet",
			imageId: "2da8986d-ed19-496e-b468-feb75aff9600",
			primaryColor: "#4B0082"
		},
		chains: [
			"koinos:EiAAKqFi-puoXnuJTdn7qBGGJa8yd-dc",
			"koinos:EiBZK_GGVP0H_fXVAM3j6EAuz3-B-l3e"
		],
		mobile: {
			androidId: "com.adrihoke.konio",
			ios: "",
			native: "konio://wc"
		},
		name: "Konio",
		shortName: "konio",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	gateio: {
		brand: {
			alt: "Gate.io Wallet",
			imageId: "6e528abf-7a7d-47bd-d84d-481f169b1200"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:10000",
			"eip155:1028",
			"eip155:128",
			"eip155:137",
			"eip155:25",
			"eip155:250",
			"eip155:256",
			"eip155:280",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:5",
			"eip155:53",
			"eip155:56",
			"eip155:65",
			"eip155:66",
			"eip155:71393",
			"eip155:85",
			"eip155:86",
			"eip155:97",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		mobile: {
			android: "https://www.gateex.cc/zh/mobileapp",
			ios: "https://www.gateex.cc/zh/mobileapp",
			native: "gtweb3wallet://wc"
		},
		name: "Gate.io",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	utorg: {
		brand: {
			alt: "UTORG Wallet",
			imageId: "39c77c0b-d6ea-419d-92b7-513a5eac2c00"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:1313161554",
			"eip155:324",
			"eip155:42161",
			"eip155:43114",
			"eip155:59144",
			"solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ"
		],
		desktop: {
			universal: "https://utorg.app/"
		},
		mobile: {
			androidId: "com.utorg",
			iosId: "id6444720908",
			native: "utorg://wc",
			universal: "https://link.utorg.com/zp0f/wc"
		},
		name: "UTORG",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	argentx: {
		brand: {
			alt: "Argent Wallet",
			primaryColor: "#FF875B",
			spriteId: "argentx"
		},
		desktop: {
			chromeId: "dlcobpjiigpikoobohmabehhmhfoodbb",
			firefoxId: "argent-x"
		},
		name: "Argent X"
	},
	blocto: {
		brand: {
			alt: "Blocto Wallet",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		group: "blocto",
		mobile: {
			androidId: "com.portto.blocto",
			iosId: "id1481181682"
		},
		name: "Blocto (Flow)"
	},
	bloctoevm: {
		brand: {
			alt: "Blocto Wallet",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		group: "blocto",
		mobile: {
			androidId: "com.portto.blocto",
			iosId: "id1481181682"
		},
		name: "Blocto (EVM)"
	},
	bloctoinjected: {
		brand: {
			alt: "Blocto Wallet",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		mobile: {
			androidId: "com.portto.blocto",
			iosId: "id1481181682"
		},
		name: "Blocto (App)",
		showOnlyIfInstalled: true
	},
	braavos: {
		brand: {
			alt: "Braavos Wallet",
			primaryColor: "#FABB38",
			spriteId: "braavos"
		},
		desktop: {
			chromeId: "jnlgamecbpmbajjfhmmmlhejkemejdma",
			edgeId: "hkkpjehhcnhgefhbdcgfkeegglpjchdc",
			firefoxId: "braavos-wallet"
		},
		mobile: {
			androidId: "app.braavos.wallet",
			iosId: "id1636013523"
		},
		name: "Braavos"
	},
	braveevm: {
		brand: {
			alt: "Brave Browser",
			primaryColor: "#F39020",
			spriteId: "brave"
		},
		group: "brave",
		mobile: {
			androidId: "com.brave.browser",
			iosId: "id1052879175"
		},
		name: "Brave Browser (EVM)"
	},
	bravesol: {
		brand: {
			alt: "Brave Browser",
			primaryColor: "#4B49C6",
			spriteId: "brave"
		},
		group: "brave",
		mobile: {
			androidId: "com.brave.browser",
			iosId: "id1052879175"
		},
		name: "Brave Browser (Solana)"
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		group: "coinbase",
		mobile: {
			androidId: "org.toshi",
			iosId: "id1278383455"
		},
		name: "Coinbase Wallet"
	},
	coinbasesolana: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		group: "coinbase",
		name: "Coinbase Wallet (Solana)"
	},
	dapper: {
		brand: {
			alt: "Dapper Wallet",
			primaryColor: "#762FBE",
			spriteId: "dapper"
		},
		mobile: {
			android: "fake-to-get-dapper-to-appear",
			ios: "fake-to-get-dapper-to-appear"
		},
		name: "Dapper"
	},
	exodusevm: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		group: "exodus",
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820"
		},
		name: "Exodus Wallet (EVM)"
	},
	exodussol: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		group: "exodus",
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820"
		},
		name: "Exodus Wallet (Solana)"
	},
	fortmatic: {
		brand: {
			alt: "Fortmatic",
			primaryColor: "#6851FF",
			spriteId: "fortmatic"
		},
		name: "Fortmatic"
	},
	frame: {
		brand: {
			alt: "Frame Wallet",
			spriteId: "frame"
		},
		desktop: {
			chromeId: "ldcoohedfbjoobcadoglnnmmfbdlmmhf"
		},
		name: "Frame"
	},
	gamestop: {
		brand: {
			alt: "GameStop Wallet",
			spriteId: "gamestop"
		},
		desktop: {
			chromeId: "pkkjjapmlcncipeecdmlhaipahfdphkd"
		},
		name: "GameStop"
	},
	glow: {
		brand: {
			alt: "Glow Wallet",
			spriteId: "glow"
		},
		desktop: {
			chromeId: "ojbcfhjmpigfobfclfflafhblgemeidi",
			edgeId: "niihfokdlimbddhfmngnplgfcgpmlido",
			firefoxId: "glow-solana-wallet"
		},
		name: "Glow"
	},
	injectedwallet: {
		brand: {
			alt: "Injected Wallet",
			spriteId: "injectedwallet"
		},
		name: "Injected Wallet",
		showOnlyIfInstalled: true
	},
	keplraxelar: {
		brand: {
			alt: "Keplr Wallet",
			primaryColor: "#314FDF",
			spriteId: "keplr"
		},
		name: "Keplr (Axelar)"
	},
	keplrcosmoshub: {
		brand: {
			alt: "Keplr Wallet",
			primaryColor: "#314FDF",
			spriteId: "keplr"
		},
		name: "Keplr (Cosmoshub)"
	},
	keplrosmosis: {
		brand: {
			alt: "Keplr Wallet",
			primaryColor: "#314FDF",
			spriteId: "keplr"
		},
		name: "Keplr (Osmosis)"
	},
	magicemailotp: {
		brand: {
			alt: "Magic Email OTP",
			spriteId: "magiclink"
		},
		name: "Magic Email OTP"
	},
	magiclink: {
		brand: {
			alt: "Magic Link",
			spriteId: "magiclink"
		},
		name: "Magic Link"
	},
	magicsocial: {
		brand: {
			alt: "Magic Social",
			spriteId: "magiclink"
		},
		name: "Magic Social"
	},
	myalgo: {
		brand: {
			alt: "MyAlgo Wallet",
			spriteId: "myalgo"
		},
		name: "MyAlgo"
	},
	opera: {
		brand: {
			alt: "Opera Wallet",
			primaryColor: "#F39020",
			spriteId: "opera"
		},
		name: "Opera Wallet"
	},
	phantom: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom"
	},
	phantomevm: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom (EVM)"
	},
	phantomledger: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom (Ledger)"
	},
	slope: {
		brand: {
			alt: "Slope Wallet",
			primaryColor: "#6E66FA",
			spriteId: "slope"
		},
		desktop: {
			chromeId: "pocmplpaccanhmnllbbkpgfliimjljgo"
		},
		mobile: {
			androidId: "com.wd.wallet",
			iosId: "id1574624530"
		},
		name: "Slope"
	},
	solflare: {
		brand: {
			alt: "Solflare Wallet",
			primaryColor: "#FC7227",
			spriteId: "solflare"
		},
		desktop: {
			chromeId: "bhhhlbepdkbapadjdnnojkbgioiodbic"
		},
		name: "Solflare"
	},
	superb: {
		brand: {
			primaryColor: "#FF008A",
			spriteId: "superb"
		},
		desktop: {
			chromeId: "ihhmoeonfhbinhpknjpldgbdaiadkgdp"
		},
		name: "Superb"
	},
	tallyho: {
		brand: {
			alt: "Tally Ho Wallet",
			spriteId: "tallyho"
		},
		desktop: {
			chromeId: "eajafomhmkipbjmfmhebemolkcicgfmd"
		},
		name: "Tally Ho"
	},
	walletconnect: {
		brand: {
			alt: "WalletConnect",
			primaryColor: "#3182CE",
			spriteId: "walletconnect"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1438144202"
		},
		name: "WalletConnect"
	}
};
var walletBook = {
	groups: groups,
	wallets: wallets
};

export { walletBook as default, groups, wallets };
